import ractive from 'https://cdn.jsdelivr.net/npm/ractive@1.4.4/runtime.min.mjs';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
// eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
// eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
// eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function () {
      return 7;
    }
  })[1] !== 7;
});

var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () {/* empty */}.bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var call$2 = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var functionCall = functionBindNative ? call$2.bind(call$2) : function () {
  return call$2.apply(call$2, arguments);
};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({
  1: 2
}, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$5 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var objectPropertyIsEnumerable = {
  f: f$5
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype$2 = Function.prototype;
var call$1 = FunctionPrototype$2.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = functionBindNative && FunctionPrototype$2.bind.bind(call$1, call$1);
var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$1.apply(fn, arguments);
  };
};

var toString$1 = functionUncurryThis({}.toString);
var stringSlice = functionUncurryThis(''.slice);
var classofRaw = function (it) {
  return stringSlice(toString$1(it), 8, -1);
};

var $Object$4 = Object;
var split = functionUncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function (it) {
  return it === null || it === undefined;
};

var $TypeError$d = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError$d("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings

var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isObject = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};
var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis_1[namespace]) : globalThis_1[namespace] && globalThis_1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var navigator = globalThis_1.navigator;
var userAgent = navigator && navigator.userAgent;
var environmentUserAgent = userAgent ? String(userAgent) : '';

var process = globalThis_1.process;
var Deno = globalThis_1.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && environmentUserAgent) {
  match = environmentUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = environmentUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}
var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var $String$4 = globalThis_1.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$4(symbol) || !(Object(symbol) instanceof Symbol) ||
  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && environmentV8Version && environmentV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && typeof Symbol.iterator == 'symbol';

var $Object$3 = Object;
var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$3(it));
};

var $String$3 = String;
var tryToString = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$c = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError$c(tryToString(argument) + ' is not a function');
};

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$b = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  throw new $TypeError$b("Can't convert object to primitive value");
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;
var defineGlobalProperty = function (key, value) {
  try {
    defineProperty$1(globalThis_1, key, {
      value: value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    globalThis_1[key] = value;
  }
  return value;
};

var sharedStore = createCommonjsModule(function (module) {

  var SHARED = '__core-js_shared__';
  var store = module.exports = globalThis_1[SHARED] || defineGlobalProperty(SHARED, {});
  (store.versions || (store.versions = [])).push({
    version: '3.47.0',
    mode: 'global',
    copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)',
    license: 'https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
  });
});

var shared = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value || {});
};

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return $Object$2(requireObjectCoercible(argument));
};

var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var id = 0;
var postfix = Math.random();
var toString = functionUncurryThis(1.1.toString);
var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

var Symbol$1 = globalThis_1.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;
var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name) ? Symbol$1[name] : createWellKnownSymbol('Symbol.' + name);
  }
  return WellKnownSymbolsStore[name];
};

var $TypeError$a = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError$a("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var document$1 = globalThis_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject(document$1) && isObject(document$1.createElement);
var documentCreateElement = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () {
      return 7;
    }
  }).a !== 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$4 = descriptors ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) {/* empty */}
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
  f: f$4
};

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () {/* empty */}, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var $String$2 = String;
var $TypeError$9 = TypeError;

// `Assert: Type(argument) is Object`
var anObject = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError$9($String$2(argument) + ' is not an object');
};

var $TypeError$8 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$3 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }
  return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$8('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty = {
  f: f$3
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwnProperty_1(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
var CONFIGURABLE = EXISTS && (!descriptors || descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable);
var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var functionToString = functionUncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString(it);
  };
}
var inspectSource = sharedStore.inspectSource;

var WeakMap$1 = globalThis_1.WeakMap;
var weakMapBasicDetection = isCallable(WeakMap$1) && /native code/.test(String(WeakMap$1));

var keys = shared('keys');
var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$1 = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = globalThis_1.TypeError;
var WeakMap = globalThis_1.WeakMap;
var set, get, has$1;
var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};
var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    }
    return state;
  };
};
if (weakMapBasicDetection || sharedStore.state) {
  var store = sharedStore.state || (sharedStore.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has$1 = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$1[STATE] = true;
  set = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}
var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var makeBuiltIn_1 = createCommonjsModule(function (module) {

  var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
  var enforceInternalState = internalState.enforce;
  var getInternalState = internalState.get;
  var $String = String;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  var defineProperty = Object.defineProperty;
  var stringSlice = functionUncurryThis(''.slice);
  var replace = functionUncurryThis(''.replace);
  var join = functionUncurryThis([].join);
  var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
    return defineProperty(function () {/* empty */}, 'length', {
      value: 8
    }).length !== 8;
  });
  var TEMPLATE = String(String).split('String');
  var makeBuiltIn = module.exports = function (value, name, options) {
    if (stringSlice($String(name), 0, 7) === 'Symbol(') {
      name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    }
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!hasOwnProperty_1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
      if (descriptors) defineProperty(value, 'name', {
        value: name,
        configurable: true
      });else value.name = name;
    }
    if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
      defineProperty(value, 'length', {
        value: options.arity
      });
    }
    try {
      if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
        if (descriptors) defineProperty(value, 'prototype', {
          writable: false
        });
        // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
      } else if (value.prototype) value.prototype = undefined;
    } catch (error) {/* empty */}
    var state = enforceInternalState(value);
    if (!hasOwnProperty_1(state, 'source')) {
      state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
    }
    return value;
  };

  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  // eslint-disable-next-line no-extend-native -- required
  Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
  }, 'toString');
});

var defineBuiltIn = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
    } catch (error) {/* empty */}
    if (simple) O[key] = value;else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  }
  return O;
};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;
var push$3 = functionUncurryThis([].push);
var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwnProperty_1(hiddenKeys$1, key) && hasOwnProperty_1(O, key) && push$3(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf(result, key) || push$3(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$2 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys);
};
var objectGetOwnPropertyNames = {
  f: f$2
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$1 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
  f: f$1
};

var concat = functionUncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;
var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
var isForced_1 = isForced;

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis_1;
  } else if (STATIC) {
    target = globalThis_1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis_1[TARGET] && globalThis_1[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var $TypeError$7 = TypeError;
var anInstance = function (it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw new $TypeError$7('Incorrect invocation');
};

var correctPrototypeGetter = !fails(function () {
  function F() {/* empty */}
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }
  return object instanceof $Object$1 ? ObjectPrototype : null;
};

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, {
    getter: true
  });
  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, {
    setter: true
  });
  return objectDefineProperty.f(target, name, descriptor);
};

var createProperty = function (object, key, value) {
  if (descriptors) objectDefineProperty.f(object, key, createPropertyDescriptor(0, value));else object[key] = value;
};

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var f = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
  return O;
};
var objectDefineProperties = {
  f: f
};

var html = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');
var EmptyConstructor = function () {/* empty */};
var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) {/* ignore */}
  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};
hiddenKeys$1[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

var ITERATOR$3 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}
var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype$2[ITERATOR$3])) {
  defineBuiltIn(IteratorPrototype$2, ITERATOR$3, function () {
    return this;
  });
}
var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var CONSTRUCTOR = 'constructor';
var ITERATOR$2 = 'Iterator';
var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var $TypeError$6 = TypeError;
var NativeIterator = globalThis_1[ITERATOR$2];

// FF56- have non-standard global helper `Iterator`
var FORCED$3 = !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype$1
// FF44- non-standard `Iterator` passes previous tests
|| !fails(function () {
  NativeIterator({});
});
var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype$1);
  if (objectGetPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError$6('Abstract class Iterator not directly constructable');
};
var defineIteratorPrototypeAccessor = function (key, value) {
  if (descriptors) {
    defineBuiltInAccessor(IteratorPrototype$1, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject(this);
        if (this === IteratorPrototype$1) throw new $TypeError$6("You can't redefine this property");
        if (hasOwnProperty_1(this, key)) this[key] = replacement;else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype$1[key] = value;
};
if (!hasOwnProperty_1(IteratorPrototype$1, TO_STRING_TAG$3)) defineIteratorPrototypeAccessor(TO_STRING_TAG$3, ITERATOR$2);
if (FORCED$3 || !hasOwnProperty_1(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}
IteratorConstructor.prototype = IteratorPrototype$1;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
_export({
  global: true,
  constructor: true,
  forced: FORCED$3
}, {
  Iterator: IteratorConstructor
});

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
};

var bind = functionUncurryThisClause(functionUncurryThisClause.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function /* ...args */
  () {
    return fn.apply(that, arguments);
  };
};

var iterators = {};

var ITERATOR$1 = wellKnownSymbol('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR$1] === it);
};

var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
var test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
test[TO_STRING_TAG$2] = 'z';
var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () {
  return arguments;
}()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) {/* empty */}
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$1)) == 'string' ? tag
  // builtinTag case
  : CORRECT_ARGUMENTS ? classofRaw(O)
  // ES3 arguments fallback
  : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var ITERATOR = wellKnownSymbol('iterator');
var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || iterators[classof(it)];
};

var $TypeError$5 = TypeError;
var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw new $TypeError$5(tryToString(argument) + ' is not iterable');
};

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

var $TypeError$4 = TypeError;
var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};
var ResultPrototype = Result.prototype;
var iterate = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;
  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal');
    return new Result(true, condition);
  };
  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }
    return INTERRUPTED ? fn(value, stop) : fn(value);
  };
  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError$4(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
      }
      return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }
  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = functionCall(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
  }
  return new Result(false);
};

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/ecma262/#sec-getiteratordirect
var getIteratorDirect = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

// https://github.com/tc39/ecma262/pull/3467
var iteratorHelperWithoutClosingOnEarlyError = function (METHOD_NAME, ExpectedError) {
  var Iterator = globalThis_1.Iterator;
  var IteratorPrototype = Iterator && Iterator.prototype;
  var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];
  var CLOSED = false;
  if (method) try {
    method.call({
      next: function () {
        return {
          done: true
        };
      },
      'return': function () {
        CLOSED = true;
      }
    }, -1);
  } catch (error) {
    // https://bugs.webkit.org/show_bug.cgi?id=291195
    if (!(error instanceof ExpectedError)) CLOSED = false;
  }
  if (!CLOSED) return method;
};

var findWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('find', TypeError);

// `Iterator.prototype.find` method
// https://tc39.es/ecma262/#sec-iterator.prototype.find
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: findWithoutClosingOnEarlyError
}, {
  find: function find(predicate) {
    anObject(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (findWithoutClosingOnEarlyError) return functionCall(findWithoutClosingOnEarlyError, this, predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).result;
  }
});

var forEachWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('forEach', TypeError);

// `Iterator.prototype.forEach` method
// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: forEachWithoutClosingOnEarlyError
}, {
  forEach: function forEach(fn) {
    anObject(this);
    try {
      aCallable(fn);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (forEachWithoutClosingOnEarlyError) return functionCall(forEachWithoutClosingOnEarlyError, this, fn);
    var record = getIteratorDirect(this);
    var counter = 0;
    iterate(record, function (value) {
      fn(value, counter++);
    }, {
      IS_RECORD: true
    });
  }
});

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(argument) {
  return classofRaw(argument) === 'Array';
};

var $String$1 = String;
var toString_1 = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var $SyntaxError = SyntaxError;
var $parseInt = parseInt;
var fromCharCode = String.fromCharCode;
var at$1 = functionUncurryThis(''.charAt);
var slice$2 = functionUncurryThis(''.slice);
var exec$2 = functionUncurryThis(/./.exec);
var codePoints = {
  '\\"': '"',
  '\\\\': '\\',
  '\\/': '/',
  '\\b': '\b',
  '\\f': '\f',
  '\\n': '\n',
  '\\r': '\r',
  '\\t': '\t'
};
var IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
// eslint-disable-next-line regexp/no-control-character -- safe
var IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
var parseJsonString = function (source, i) {
  var unterminated = true;
  var value = '';
  while (i < source.length) {
    var chr = at$1(source, i);
    if (chr === '\\') {
      var twoChars = slice$2(source, i, i + 2);
      if (hasOwnProperty_1(codePoints, twoChars)) {
        value += codePoints[twoChars];
        i += 2;
      } else if (twoChars === '\\u') {
        i += 2;
        var fourHexDigits = slice$2(source, i, i + 4);
        if (!exec$2(IS_4_HEX_DIGITS, fourHexDigits)) throw new $SyntaxError('Bad Unicode escape at: ' + i);
        value += fromCharCode($parseInt(fourHexDigits, 16));
        i += 4;
      } else throw new $SyntaxError('Unknown escape sequence: "' + twoChars + '"');
    } else if (chr === '"') {
      unterminated = false;
      i++;
      break;
    } else {
      if (exec$2(IS_C0_CONTROL_CODE, chr)) throw new $SyntaxError('Bad control character in string literal at: ' + i);
      value += chr;
      i++;
    }
  }
  if (unterminated) throw new $SyntaxError('Unterminated string at: ' + i);
  return {
    value: value,
    end: i
  };
};

var JSON$1 = globalThis_1.JSON;
var Number$1 = globalThis_1.Number;
var SyntaxError$1 = globalThis_1.SyntaxError;
var nativeParse = JSON$1 && JSON$1.parse;
var enumerableOwnProperties = getBuiltIn('Object', 'keys');
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var at = functionUncurryThis(''.charAt);
var slice$1 = functionUncurryThis(''.slice);
var exec$1 = functionUncurryThis(/./.exec);
var push$2 = functionUncurryThis([].push);
var IS_DIGIT = /^\d$/;
var IS_NON_ZERO_DIGIT = /^[1-9]$/;
var IS_NUMBER_START = /^[\d-]$/;
var IS_WHITESPACE = /^[\t\n\r ]$/;
var PRIMITIVE = 0;
var OBJECT = 1;
var $parse = function (source, reviver) {
  source = toString_1(source);
  var context = new Context(source, 0);
  var root = context.parse();
  var value = root.value;
  var endIndex = context.skip(IS_WHITESPACE, root.end);
  if (endIndex < source.length) {
    throw new SyntaxError$1('Unexpected extra character: "' + at(source, endIndex) + '" after the parsed data at: ' + endIndex);
  }
  return isCallable(reviver) ? internalize({
    '': value
  }, '', reviver, root) : value;
};
var internalize = function (holder, name, reviver, node) {
  var val = holder[name];
  var unmodified = node && val === node.value;
  var context = unmodified && typeof node.source == 'string' ? {
    source: node.source
  } : {};
  var elementRecordsLen, keys, len, i, P;
  if (isObject(val)) {
    var nodeIsArray = isArray(val);
    var nodes = unmodified ? node.nodes : nodeIsArray ? [] : {};
    if (nodeIsArray) {
      elementRecordsLen = nodes.length;
      len = lengthOfArrayLike(val);
      for (i = 0; i < len; i++) {
        internalizeProperty(val, i, internalize(val, '' + i, reviver, i < elementRecordsLen ? nodes[i] : undefined));
      }
    } else {
      keys = enumerableOwnProperties(val);
      len = lengthOfArrayLike(keys);
      for (i = 0; i < len; i++) {
        P = keys[i];
        internalizeProperty(val, P, internalize(val, P, reviver, hasOwnProperty_1(nodes, P) ? nodes[P] : undefined));
      }
    }
  }
  return functionCall(reviver, holder, name, val, context);
};
var internalizeProperty = function (object, key, value) {
  if (descriptors) {
    var descriptor = getOwnPropertyDescriptor$1(object, key);
    if (descriptor && !descriptor.configurable) return;
  }
  if (value === undefined) delete object[key];else createProperty(object, key, value);
};
var Node = function (value, end, source, nodes) {
  this.value = value;
  this.end = end;
  this.source = source;
  this.nodes = nodes;
};
var Context = function (source, index) {
  this.source = source;
  this.index = index;
};

// https://www.json.org/json-en.html
Context.prototype = {
  fork: function (nextIndex) {
    return new Context(this.source, nextIndex);
  },
  parse: function () {
    var source = this.source;
    var i = this.skip(IS_WHITESPACE, this.index);
    var fork = this.fork(i);
    var chr = at(source, i);
    if (exec$1(IS_NUMBER_START, chr)) return fork.number();
    switch (chr) {
      case '{':
        return fork.object();
      case '[':
        return fork.array();
      case '"':
        return fork.string();
      case 't':
        return fork.keyword(true);
      case 'f':
        return fork.keyword(false);
      case 'n':
        return fork.keyword(null);
    }
    throw new SyntaxError$1('Unexpected character: "' + chr + '" at: ' + i);
  },
  node: function (type, value, start, end, nodes) {
    return new Node(value, end, type ? null : slice$1(this.source, start, end), nodes);
  },
  object: function () {
    var source = this.source;
    var i = this.index + 1;
    var expectKeypair = false;
    var object = {};
    var nodes = {};
    while (i < source.length) {
      i = this.until(['"', '}'], i);
      if (at(source, i) === '}' && !expectKeypair) {
        i++;
        break;
      }
      // Parsing the key
      var result = this.fork(i).string();
      var key = result.value;
      i = result.end;
      i = this.until([':'], i) + 1;
      // Parsing value
      i = this.skip(IS_WHITESPACE, i);
      result = this.fork(i).parse();
      createProperty(nodes, key, result);
      createProperty(object, key, result.value);
      i = this.until([',', '}'], result.end);
      var chr = at(source, i);
      if (chr === ',') {
        expectKeypair = true;
        i++;
      } else if (chr === '}') {
        i++;
        break;
      }
    }
    return this.node(OBJECT, object, this.index, i, nodes);
  },
  array: function () {
    var source = this.source;
    var i = this.index + 1;
    var expectElement = false;
    var array = [];
    var nodes = [];
    while (i < source.length) {
      i = this.skip(IS_WHITESPACE, i);
      if (at(source, i) === ']' && !expectElement) {
        i++;
        break;
      }
      var result = this.fork(i).parse();
      push$2(nodes, result);
      push$2(array, result.value);
      i = this.until([',', ']'], result.end);
      if (at(source, i) === ',') {
        expectElement = true;
        i++;
      } else if (at(source, i) === ']') {
        i++;
        break;
      }
    }
    return this.node(OBJECT, array, this.index, i, nodes);
  },
  string: function () {
    var index = this.index;
    var parsed = parseJsonString(this.source, this.index + 1);
    return this.node(PRIMITIVE, parsed.value, index, parsed.end);
  },
  number: function () {
    var source = this.source;
    var startIndex = this.index;
    var i = startIndex;
    if (at(source, i) === '-') i++;
    if (at(source, i) === '0') i++;else if (exec$1(IS_NON_ZERO_DIGIT, at(source, i))) i = this.skip(IS_DIGIT, i + 1);else throw new SyntaxError$1('Failed to parse number at: ' + i);
    if (at(source, i) === '.') i = this.skip(IS_DIGIT, i + 1);
    if (at(source, i) === 'e' || at(source, i) === 'E') {
      i++;
      if (at(source, i) === '+' || at(source, i) === '-') i++;
      var exponentStartIndex = i;
      i = this.skip(IS_DIGIT, i);
      if (exponentStartIndex === i) throw new SyntaxError$1("Failed to parse number's exponent value at: " + i);
    }
    return this.node(PRIMITIVE, Number$1(slice$1(source, startIndex, i)), startIndex, i);
  },
  keyword: function (value) {
    var keyword = '' + value;
    var index = this.index;
    var endIndex = index + keyword.length;
    if (slice$1(this.source, index, endIndex) !== keyword) throw new SyntaxError$1('Failed to parse value at: ' + index);
    return this.node(PRIMITIVE, value, index, endIndex);
  },
  skip: function (regex, i) {
    var source = this.source;
    for (; i < source.length; i++) if (!exec$1(regex, at(source, i))) break;
    return i;
  },
  until: function (array, i) {
    i = this.skip(IS_WHITESPACE, i);
    var chr = at(this.source, i);
    for (var j = 0; j < array.length; j++) if (array[j] === chr) return i;
    throw new SyntaxError$1('Unexpected character: "' + chr + '" at: ' + i);
  }
};
var NO_SOURCE_SUPPORT = fails(function () {
  var unsafeInt = '9007199254740993';
  var source;
  nativeParse(unsafeInt, function (key, value, context) {
    source = context.source;
  });
  return source !== unsafeInt;
});
var PROPER_BASE_PARSE = symbolConstructorDetection && !fails(function () {
  // Safari 9 bug
  return 1 / nativeParse('-0 \t') !== -Infinity;
});

// `JSON.parse` method
// https://tc39.es/ecma262/#sec-json.parse
// https://github.com/tc39/proposal-json-parse-with-source
_export({
  target: 'JSON',
  stat: true,
  forced: NO_SOURCE_SUPPORT
}, {
  parse: function parse(text, reviver) {
    return PROPER_BASE_PARSE && !isCallable(reviver) ? nativeParse(text) : $parse(text, reviver);
  }
});

Math.log10 = Math.log10 || function (x) {
  return Math.log(x) * Math.LOG10E;
};

var $TypeError$3 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();
var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError$3('Cannot set read only .length');
  }
  return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$2 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$2('Maximum allowed index exceeded');
  return it;
};

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({
    length: 0x100000000
  }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};
var FORCED$2 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
_export({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: FORCED$2
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    arraySetLength(O, len);
    return len;
  }
});

var arrayFromConstructorAndList = function (Constructor, list, $length) {
  var index = 0;
  var length = arguments.length > 2 ? $length : lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var getBuiltInPrototypeMethod = function (CONSTRUCTOR, METHOD) {
  var Constructor = globalThis_1[CONSTRUCTOR];
  var Prototype = Constructor && Constructor.prototype;
  return Prototype && Prototype[METHOD];
};

var defineProperty = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $Array = Array;
var sort = functionUncurryThis(getBuiltInPrototypeMethod('Array', 'sort'));

// `Array.prototype.toSorted` method
// https://tc39.es/ecma262/#sec-array.prototype.tosorted
_export({
  target: 'Array',
  proto: true
}, {
  toSorted: function toSorted(compareFn) {
    if (compareFn !== undefined) aCallable(compareFn);
    var O = toIndexedObject(this);
    var A = arrayFromConstructorAndList($Array, O);
    return sort(A, compareFn);
  }
});
addToUnscopables('toSorted');

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

var getInternalState = internalState.get;
var isRawJson = function isRawJSON(O) {
  if (!isObject(O)) return false;
  var state = getInternalState(O);
  return !!state && state.type === 'RawJSON';
};

var arraySlice = functionUncurryThis([].slice);

/* eslint-disable es/no-json -- safe */

var nativeRawJson = !fails(function () {
  var unsafeInt = '9007199254740993';
  // eslint-disable-next-line es/no-nonstandard-json-properties -- feature detection
  var raw = JSON.rawJSON(unsafeInt);
  // eslint-disable-next-line es/no-nonstandard-json-properties -- feature detection
  return !JSON.isRawJSON(raw) || JSON.stringify(raw) !== unsafeInt;
});

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = functionUncurryThis(/./.exec);
var charAt = functionUncurryThis(''.charAt);
var charCodeAt = functionUncurryThis(''.charCodeAt);
var replace = functionUncurryThis(''.replace);
var slice = functionUncurryThis(''.slice);
var push$1 = functionUncurryThis([].push);
var numberToString = functionUncurryThis(1.1.toString);
var surrogates = /[\uD800-\uDFFF]/g;
var lowSurrogates = /^[\uD800-\uDBFF]$/;
var hiSurrogates = /^[\uDC00-\uDFFF]$/;
var MARK = uid();
var MARK_LENGTH = MARK.length;
var WRONG_SYMBOLS_CONVERSION = !symbolConstructorDetection || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
  // WebKit converts symbol values to JSON as null
  || $stringify({
    a: symbol
  }) !== '{}'
  // V8 throws on boxed symbols
  || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
});
var stringifyWithProperSymbolsConversion = WRONG_SYMBOLS_CONVERSION ? function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = functionCall($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return functionApply($stringify, null, args);
} : $stringify;
var fixIllFormedJSON = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if (exec(lowSurrogates, match) && !exec(hiSurrogates, next) || exec(hiSurrogates, match) && !exec(lowSurrogates, prev)) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  }
  return match;
};
var getReplacerFunction = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push$1(keys, element);else if (typeof element == 'number' || classofRaw(element) === 'Number' || classofRaw(element) === 'String') push$1(keys, toString_1(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};

// `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
// https://github.com/tc39/proposal-json-parse-with-source
if ($stringify) _export({
  target: 'JSON',
  stat: true,
  arity: 3,
  forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE || !nativeRawJson
}, {
  stringify: function stringify(text, replacer, space) {
    var replacerFunction = getReplacerFunction(replacer);
    var rawStrings = [];
    var json = stringifyWithProperSymbolsConversion(text, function (key, value) {
      // some old implementations (like WebKit) could pass numbers as keys
      var v = isCallable(replacerFunction) ? functionCall(replacerFunction, this, $String(key), value) : value;
      return !nativeRawJson && isRawJson(v) ? MARK + (push$1(rawStrings, v.rawJSON) - 1) : v;
    }, space);
    if (typeof json != 'string') return json;
    if (ILL_FORMED_UNICODE) json = replace(json, surrogates, fixIllFormedJSON);
    if (nativeRawJson) return json;
    var result = '';
    var length = json.length;
    for (var i = 0; i < length; i++) {
      var chr = charAt(json, i);
      if (chr === '"') {
        var end = parseJsonString(json, ++i).end - 1;
        var string = slice(json, i, end);
        result += slice(string, 0, MARK_LENGTH) === MARK ? rawStrings[slice(string, MARK_LENGTH)] : '"' + string + '"';
        i = end;
      } else result += chr;
    }
    return result;
  }
});

var defineBuiltIns = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return {
    value: value,
    done: done
  };
};

var iteratorCloseAll = function (iters, kind, value) {
  for (var i = iters.length - 1; i >= 0; i--) {
    if (iters[i] === undefined) continue;
    try {
      value = iteratorClose(iters[i].iterator, kind, value);
    } catch (error) {
      kind = 'throw';
      value = error;
    }
  }
  if (kind === 'throw') throw value;
  return value;
};

var IteratorPrototype = iteratorsCore.IteratorPrototype;
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var NORMAL = 'normal';
var THROW = 'throw';
var setInternalState = internalState.set;
var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = internalState.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);
  return defineBuiltIns(objectCreate(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      if (state.done) return createIterResultObject(undefined, true);
      try {
        var result = state.nextHandler();
        return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod(iterator, 'return');
        return returnMethod ? functionCall(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose(state.inner.iterator, NORMAL);
      } catch (error) {
        return iteratorClose(iterator, THROW, error);
      }
      if (state.openIters) try {
        iteratorCloseAll(state.openIters, NORMAL);
      } catch (error) {
        return iteratorClose(iterator, THROW, error);
      }
      if (iterator) iteratorClose(iterator, NORMAL);
      return createIterResultObject(undefined, true);
    }
  });
};
var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);
createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');
var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState(this, state);
  };
  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
  return IteratorProxy;
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

// Should throw an error on invalid iterator
// https://issues.chromium.org/issues/336839115
var iteratorHelperThrowsOnInvalidIterator = function (methodName, argument) {
  // eslint-disable-next-line es/no-iterator -- required for testing
  var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
  if (method) try {
    method.call({
      next: null
    }, argument).next();
  } catch (error) {
    return true;
  }
};

var FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('filter', function () {/* empty */});
var filterWithoutClosingOnEarlyError = !FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('filter', TypeError);
var FORCED$1 = FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR || filterWithoutClosingOnEarlyError;
var IteratorProxy$1 = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject(functionCall(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://tc39.es/ecma262/#sec-iterator.prototype.filter
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: FORCED$1
}, {
  filter: function filter(predicate) {
    anObject(this);
    try {
      aCallable(predicate);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (filterWithoutClosingOnEarlyError) return functionCall(filterWithoutClosingOnEarlyError, this, predicate);
    return new IteratorProxy$1(getIteratorDirect(this), {
      predicate: predicate
    });
  }
});

var MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('map', function () {/* empty */});
var mapWithoutClosingOnEarlyError = !MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('map', TypeError);
var FORCED = MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || mapWithoutClosingOnEarlyError;
var IteratorProxy = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var result = anObject(functionCall(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://tc39.es/ecma262/#sec-iterator.prototype.map
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: FORCED
}, {
  map: function map(mapper) {
    anObject(this);
    try {
      aCallable(mapper);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    if (mapWithoutClosingOnEarlyError) return functionCall(mapWithoutClosingOnEarlyError, this, mapper);
    return new IteratorProxy(getIteratorDirect(this), {
      mapper: mapper
    });
  }
});

var $TypeError$1 = TypeError;

// https://bugs.webkit.org/show_bug.cgi?id=291651
var FAILS_ON_INITIAL_UNDEFINED = fails(function () {
  // eslint-disable-next-line es/no-iterator-prototype-reduce, es/no-array-prototype-keys, array-callback-return -- required for testing
  [].keys().reduce(function () {/* empty */}, undefined);
});
var reduceWithoutClosingOnEarlyError = !FAILS_ON_INITIAL_UNDEFINED && iteratorHelperWithoutClosingOnEarlyError('reduce', $TypeError$1);

// `Iterator.prototype.reduce` method
// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: FAILS_ON_INITIAL_UNDEFINED || reduceWithoutClosingOnEarlyError
}, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject(this);
    try {
      aCallable(reducer);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    if (reduceWithoutClosingOnEarlyError) {
      return functionApply(reduceWithoutClosingOnEarlyError, this, noInitial ? [reducer] : [reducer, accumulator]);
    }
    var record = getIteratorDirect(this);
    var counter = 0;
    iterate(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, {
      IS_RECORD: true
    });
    if (noInitial) throw new $TypeError$1('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});

var $TypeError = TypeError;
var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};

var $URLSearchParams$1 = URLSearchParams;
var URLSearchParamsPrototype$2 = $URLSearchParams$1.prototype;
var append = functionUncurryThis(URLSearchParamsPrototype$2.append);
var $delete = functionUncurryThis(URLSearchParamsPrototype$2['delete']);
var forEach$1 = functionUncurryThis(URLSearchParamsPrototype$2.forEach);
var push = functionUncurryThis([].push);
var params$1 = new $URLSearchParams$1('a=1&a=2&b=3');
params$1['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params$1['delete']('b', undefined);
if (params$1 + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype$2, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach$1(this, function (v, k) {
      // also validates `this`
      push(entries, {
        key: k,
        value: v
      });
    });
    validateArgumentsLength(length, 1);
    var key = toString_1(name);
    var value = toString_1($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, {
    enumerable: true,
    unsafe: true
  });
}

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype$1 = $URLSearchParams.prototype;
var getAll = functionUncurryThis(URLSearchParamsPrototype$1.getAll);
var $has = functionUncurryThis(URLSearchParamsPrototype$1.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn(URLSearchParamsPrototype$1, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString_1($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    }
    return false;
  }, {
    enumerable: true,
    unsafe: true
  });
}

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = functionUncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (descriptors && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () {
        count++;
      });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}

var newHost = "img.jsdelivr.com";
var hosts = [
	"cloud.githubusercontent.com",
	"img.shields.io",
	"img.badgesize.io",
	"raw.githubusercontent.com",
	"github.com",
	"upload.wikimedia.org",
	"opencollective.com",
	"flat.badgen.net",
	"images.opencollective.com",
	"avatars.githubusercontent.com",
	"badgen.net"
];
var optimizedHosts$1 = {
	newHost: newHost,
	hosts: hosts
};

var optimizedHosts$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	newHost: newHost,
	hosts: hosts,
	'default': optimizedHosts$1
});

var countries = [
	{
		code: "AD",
		name: "Andorra"
	},
	{
		code: "AE",
		name: "United Arab Emirates"
	},
	{
		code: "AF",
		name: "Afghanistan"
	},
	{
		code: "AG",
		name: "Antigua and Barbuda"
	},
	{
		code: "AI",
		name: "Anguilla"
	},
	{
		code: "AL",
		name: "Albania"
	},
	{
		code: "AM",
		name: "Armenia"
	},
	{
		code: "AO",
		name: "Angola"
	},
	{
		code: "AQ",
		name: "Antarctica"
	},
	{
		code: "AR",
		name: "Argentina"
	},
	{
		code: "AS",
		name: "American Samoa"
	},
	{
		code: "AT",
		name: "Austria"
	},
	{
		code: "AU",
		name: "Australia"
	},
	{
		code: "AW",
		name: "Aruba"
	},
	{
		code: "AX",
		name: "Åland"
	},
	{
		code: "AZ",
		name: "Azerbaijan"
	},
	{
		code: "BA",
		name: "Bosnia and Herzegovina"
	},
	{
		code: "BB",
		name: "Barbados"
	},
	{
		code: "BD",
		name: "Bangladesh"
	},
	{
		code: "BE",
		name: "Belgium"
	},
	{
		code: "BF",
		name: "Burkina Faso"
	},
	{
		code: "BG",
		name: "Bulgaria"
	},
	{
		code: "BH",
		name: "Bahrain"
	},
	{
		code: "BI",
		name: "Burundi"
	},
	{
		code: "BJ",
		name: "Benin"
	},
	{
		code: "BL",
		name: "Saint Barthélemy"
	},
	{
		code: "BM",
		name: "Bermuda"
	},
	{
		code: "BN",
		name: "Brunei"
	},
	{
		code: "BO",
		name: "Bolivia"
	},
	{
		code: "BQ",
		name: "Bonaire"
	},
	{
		code: "BR",
		name: "Brazil"
	},
	{
		code: "BS",
		name: "Bahamas"
	},
	{
		code: "BT",
		name: "Bhutan"
	},
	{
		code: "BV",
		name: "Bouvet Island"
	},
	{
		code: "BW",
		name: "Botswana"
	},
	{
		code: "BY",
		name: "Belarus"
	},
	{
		code: "BZ",
		name: "Belize"
	},
	{
		code: "CA",
		name: "Canada"
	},
	{
		code: "CC",
		name: "Cocos (Keeling) Islands"
	},
	{
		code: "CD",
		name: "Democratic Republic of the Congo"
	},
	{
		code: "CF",
		name: "Central African Republic"
	},
	{
		code: "CG",
		name: "Republic of the Congo"
	},
	{
		code: "CH",
		name: "Switzerland"
	},
	{
		code: "CI",
		name: "Ivory Coast"
	},
	{
		code: "CK",
		name: "Cook Islands"
	},
	{
		code: "CL",
		name: "Chile"
	},
	{
		code: "CM",
		name: "Cameroon"
	},
	{
		code: "CN",
		name: "China"
	},
	{
		code: "CO",
		name: "Colombia"
	},
	{
		code: "CR",
		name: "Costa Rica"
	},
	{
		code: "CU",
		name: "Cuba"
	},
	{
		code: "CV",
		name: "Cape Verde"
	},
	{
		code: "CW",
		name: "Curacao"
	},
	{
		code: "CX",
		name: "Christmas Island"
	},
	{
		code: "CY",
		name: "Cyprus"
	},
	{
		code: "CZ",
		name: "Czech Republic"
	},
	{
		code: "DE",
		name: "Germany"
	},
	{
		code: "DJ",
		name: "Djibouti"
	},
	{
		code: "DK",
		name: "Denmark"
	},
	{
		code: "DM",
		name: "Dominica"
	},
	{
		code: "DO",
		name: "Dominican Republic"
	},
	{
		code: "DZ",
		name: "Algeria"
	},
	{
		code: "EC",
		name: "Ecuador"
	},
	{
		code: "EE",
		name: "Estonia"
	},
	{
		code: "EG",
		name: "Egypt"
	},
	{
		code: "EH",
		name: "Western Sahara"
	},
	{
		code: "ER",
		name: "Eritrea"
	},
	{
		code: "ES",
		name: "Spain"
	},
	{
		code: "ET",
		name: "Ethiopia"
	},
	{
		code: "FI",
		name: "Finland"
	},
	{
		code: "FJ",
		name: "Fiji"
	},
	{
		code: "FK",
		name: "Falkland Islands"
	},
	{
		code: "FM",
		name: "Micronesia"
	},
	{
		code: "FO",
		name: "Faroe Islands"
	},
	{
		code: "FR",
		name: "France"
	},
	{
		code: "GA",
		name: "Gabon"
	},
	{
		code: "GB",
		name: "United Kingdom"
	},
	{
		code: "GD",
		name: "Grenada"
	},
	{
		code: "GE",
		name: "Georgia"
	},
	{
		code: "GF",
		name: "French Guiana"
	},
	{
		code: "GG",
		name: "Guernsey"
	},
	{
		code: "GH",
		name: "Ghana"
	},
	{
		code: "GI",
		name: "Gibraltar"
	},
	{
		code: "GL",
		name: "Greenland"
	},
	{
		code: "GM",
		name: "Gambia"
	},
	{
		code: "GN",
		name: "Guinea"
	},
	{
		code: "GP",
		name: "Guadeloupe"
	},
	{
		code: "GQ",
		name: "Equatorial Guinea"
	},
	{
		code: "GR",
		name: "Greece"
	},
	{
		code: "GS",
		name: "South Georgia and the South Sandwich Islands"
	},
	{
		code: "GT",
		name: "Guatemala"
	},
	{
		code: "GU",
		name: "Guam"
	},
	{
		code: "GW",
		name: "Guinea-Bissau"
	},
	{
		code: "GY",
		name: "Guyana"
	},
	{
		code: "HK",
		name: "Hong Kong"
	},
	{
		code: "HM",
		name: "Heard Island and McDonald Islands"
	},
	{
		code: "HN",
		name: "Honduras"
	},
	{
		code: "HR",
		name: "Croatia"
	},
	{
		code: "HT",
		name: "Haiti"
	},
	{
		code: "HU",
		name: "Hungary"
	},
	{
		code: "ID",
		name: "Indonesia"
	},
	{
		code: "IE",
		name: "Ireland"
	},
	{
		code: "IL",
		name: "Israel"
	},
	{
		code: "IM",
		name: "Isle of Man"
	},
	{
		code: "IN",
		name: "India"
	},
	{
		code: "IO",
		name: "British Indian Ocean Territory"
	},
	{
		code: "IQ",
		name: "Iraq"
	},
	{
		code: "IR",
		name: "Iran"
	},
	{
		code: "IS",
		name: "Iceland"
	},
	{
		code: "IT",
		name: "Italy"
	},
	{
		code: "JE",
		name: "Jersey"
	},
	{
		code: "JM",
		name: "Jamaica"
	},
	{
		code: "JO",
		name: "Jordan"
	},
	{
		code: "JP",
		name: "Japan"
	},
	{
		code: "KE",
		name: "Kenya"
	},
	{
		code: "KG",
		name: "Kyrgyzstan"
	},
	{
		code: "KH",
		name: "Cambodia"
	},
	{
		code: "KI",
		name: "Kiribati"
	},
	{
		code: "KM",
		name: "Comoros"
	},
	{
		code: "KN",
		name: "Saint Kitts and Nevis"
	},
	{
		code: "KP",
		name: "North Korea"
	},
	{
		code: "KR",
		name: "South Korea"
	},
	{
		code: "KW",
		name: "Kuwait"
	},
	{
		code: "KY",
		name: "Cayman Islands"
	},
	{
		code: "KZ",
		name: "Kazakhstan"
	},
	{
		code: "LA",
		name: "Laos"
	},
	{
		code: "LB",
		name: "Lebanon"
	},
	{
		code: "LC",
		name: "Saint Lucia"
	},
	{
		code: "LI",
		name: "Liechtenstein"
	},
	{
		code: "LK",
		name: "Sri Lanka"
	},
	{
		code: "LR",
		name: "Liberia"
	},
	{
		code: "LS",
		name: "Lesotho"
	},
	{
		code: "LT",
		name: "Lithuania"
	},
	{
		code: "LU",
		name: "Luxembourg"
	},
	{
		code: "LV",
		name: "Latvia"
	},
	{
		code: "LY",
		name: "Libya"
	},
	{
		code: "MA",
		name: "Morocco"
	},
	{
		code: "MC",
		name: "Monaco"
	},
	{
		code: "MD",
		name: "Moldova"
	},
	{
		code: "ME",
		name: "Montenegro"
	},
	{
		code: "MF",
		name: "Saint Martin"
	},
	{
		code: "MG",
		name: "Madagascar"
	},
	{
		code: "MH",
		name: "Marshall Islands"
	},
	{
		code: "MK",
		name: "North Macedonia"
	},
	{
		code: "ML",
		name: "Mali"
	},
	{
		code: "MM",
		name: "Myanmar (Burma)"
	},
	{
		code: "MN",
		name: "Mongolia"
	},
	{
		code: "MO",
		name: "Macao"
	},
	{
		code: "MP",
		name: "Northern Mariana Islands"
	},
	{
		code: "MQ",
		name: "Martinique"
	},
	{
		code: "MR",
		name: "Mauritania"
	},
	{
		code: "MS",
		name: "Montserrat"
	},
	{
		code: "MT",
		name: "Malta"
	},
	{
		code: "MU",
		name: "Mauritius"
	},
	{
		code: "MV",
		name: "Maldives"
	},
	{
		code: "MW",
		name: "Malawi"
	},
	{
		code: "MX",
		name: "Mexico"
	},
	{
		code: "MY",
		name: "Malaysia"
	},
	{
		code: "MZ",
		name: "Mozambique"
	},
	{
		code: "NA",
		name: "Namibia"
	},
	{
		code: "NC",
		name: "New Caledonia"
	},
	{
		code: "NE",
		name: "Niger"
	},
	{
		code: "NF",
		name: "Norfolk Island"
	},
	{
		code: "NG",
		name: "Nigeria"
	},
	{
		code: "NI",
		name: "Nicaragua"
	},
	{
		code: "NL",
		name: "Netherlands"
	},
	{
		code: "NO",
		name: "Norway"
	},
	{
		code: "NP",
		name: "Nepal"
	},
	{
		code: "NR",
		name: "Nauru"
	},
	{
		code: "NU",
		name: "Niue"
	},
	{
		code: "NZ",
		name: "New Zealand"
	},
	{
		code: "OM",
		name: "Oman"
	},
	{
		code: "PA",
		name: "Panama"
	},
	{
		code: "PE",
		name: "Peru"
	},
	{
		code: "PF",
		name: "French Polynesia"
	},
	{
		code: "PG",
		name: "Papua New Guinea"
	},
	{
		code: "PH",
		name: "Philippines"
	},
	{
		code: "PK",
		name: "Pakistan"
	},
	{
		code: "PL",
		name: "Poland"
	},
	{
		code: "PM",
		name: "Saint Pierre and Miquelon"
	},
	{
		code: "PN",
		name: "Pitcairn Islands"
	},
	{
		code: "PR",
		name: "Puerto Rico"
	},
	{
		code: "PS",
		name: "Palestine"
	},
	{
		code: "PT",
		name: "Portugal"
	},
	{
		code: "PW",
		name: "Palau"
	},
	{
		code: "PY",
		name: "Paraguay"
	},
	{
		code: "QA",
		name: "Qatar"
	},
	{
		code: "RE",
		name: "Réunion"
	},
	{
		code: "RO",
		name: "Romania"
	},
	{
		code: "RS",
		name: "Serbia"
	},
	{
		code: "RU",
		name: "Russia"
	},
	{
		code: "RW",
		name: "Rwanda"
	},
	{
		code: "SA",
		name: "Saudi Arabia"
	},
	{
		code: "SB",
		name: "Solomon Islands"
	},
	{
		code: "SC",
		name: "Seychelles"
	},
	{
		code: "SD",
		name: "Sudan"
	},
	{
		code: "SE",
		name: "Sweden"
	},
	{
		code: "SG",
		name: "Singapore"
	},
	{
		code: "SH",
		name: "Saint Helena"
	},
	{
		code: "SI",
		name: "Slovenia"
	},
	{
		code: "SJ",
		name: "Svalbard and Jan Mayen"
	},
	{
		code: "SK",
		name: "Slovakia"
	},
	{
		code: "SL",
		name: "Sierra Leone"
	},
	{
		code: "SM",
		name: "San Marino"
	},
	{
		code: "SN",
		name: "Senegal"
	},
	{
		code: "SO",
		name: "Somalia"
	},
	{
		code: "SR",
		name: "Suriname"
	},
	{
		code: "SS",
		name: "South Sudan"
	},
	{
		code: "ST",
		name: "São Tomé and Príncipe"
	},
	{
		code: "SV",
		name: "El Salvador"
	},
	{
		code: "SX",
		name: "Sint Maarten"
	},
	{
		code: "SY",
		name: "Syria"
	},
	{
		code: "SZ",
		name: "Eswatini"
	},
	{
		code: "TC",
		name: "Turks and Caicos Islands"
	},
	{
		code: "TD",
		name: "Chad"
	},
	{
		code: "TF",
		name: "French Southern Territories"
	},
	{
		code: "TG",
		name: "Togo"
	},
	{
		code: "TH",
		name: "Thailand"
	},
	{
		code: "TJ",
		name: "Tajikistan"
	},
	{
		code: "TK",
		name: "Tokelau"
	},
	{
		code: "TL",
		name: "East Timor"
	},
	{
		code: "TM",
		name: "Turkmenistan"
	},
	{
		code: "TN",
		name: "Tunisia"
	},
	{
		code: "TO",
		name: "Tonga"
	},
	{
		code: "TR",
		name: "Turkey"
	},
	{
		code: "TT",
		name: "Trinidad and Tobago"
	},
	{
		code: "TV",
		name: "Tuvalu"
	},
	{
		code: "TW",
		name: "Taiwan"
	},
	{
		code: "TZ",
		name: "Tanzania"
	},
	{
		code: "UA",
		name: "Ukraine"
	},
	{
		code: "UG",
		name: "Uganda"
	},
	{
		code: "UM",
		name: "U.S. Minor Outlying Islands"
	},
	{
		code: "US",
		name: "United States"
	},
	{
		code: "UY",
		name: "Uruguay"
	},
	{
		code: "UZ",
		name: "Uzbekistan"
	},
	{
		code: "VA",
		name: "Vatican City"
	},
	{
		code: "VC",
		name: "Saint Vincent and the Grenadines"
	},
	{
		code: "VE",
		name: "Venezuela"
	},
	{
		code: "VG",
		name: "British Virgin Islands"
	},
	{
		code: "VI",
		name: "U.S. Virgin Islands"
	},
	{
		code: "VN",
		name: "Vietnam"
	},
	{
		code: "VU",
		name: "Vanuatu"
	},
	{
		code: "WF",
		name: "Wallis and Futuna"
	},
	{
		code: "WS",
		name: "Samoa"
	},
	{
		code: "XK",
		name: "Kosovo"
	},
	{
		code: "YE",
		name: "Yemen"
	},
	{
		code: "YT",
		name: "Mayotte"
	},
	{
		code: "ZA",
		name: "South Africa"
	},
	{
		code: "ZM",
		name: "Zambia"
	},
	{
		code: "ZW",
		name: "Zimbabwe"
	}
];

var countries$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': countries
});

var optimizedHosts = getCjsExportFromNamespace(optimizedHosts$2);

var COUNTRIES = getCjsExportFromNamespace(countries$1);

const screenType = {
  mobile: 480,
  tablet: 768,
  mdDesktop: 992,
  lgDesktop: 1200,
  xlDesktop: 1400
};
const PROBE_NO_TIMING_VALUE = 'time out';
const PROBE_STATUS_FAILED = 'failed';
const PROBE_STATUS_OFFLINE = 'offline';
const PROBE_STATUS_DNS_ERROR = 'dns-error';
const PROBE_STATUS_HTTP_ERROR = 'http-error';
const PROBE_STATUS_ERROR_COLOR = '#9b51e0';
const COUNTRIES_MAP = COUNTRIES.reduce((acc, country) => {
  acc[country.code] = country.name;
  return acc;
}, {});
const COUNTRY_CODE_MAP = COUNTRIES.reduce((acc, country) => {
  acc[country.name] = country.code;
  return acc;
}, {});
var _ = {
  screenType,
  isTabletScreen() {
    return screen.width > screenType.mobile && screen.width <= screenType.tablet;
  },
  isMobileScreen() {
    return screen.width <= screenType.mobile;
  },
  formatDate(date, format = 'long') {
    if (!date) {
      return '';
    }
    if (typeof date === 'string') {
      date = new Date(date);
    }
    if (format === 'short') {
      return date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short'
      });
    }
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  },
  formatDateTime(date) {
    if (!date) {
      return '';
    }
    if (typeof date === 'string') {
      date = new Date(date);
    }
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    });
  },
  formatNumber(number) {
    return Math.floor(number).toString().replace(/\d(?=(?:\d{3})+$)/g, '$& ');
  },
  makeHTTPRequest(obj) {
    let {
      method = 'GET',
      rawResponse = false,
      body,
      url,
      headers,
      responseHeadersToGet = null,
      withCredentials = false
    } = obj;
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open(method || 'GET', method === 'GET' && body ? url + this.createQueryString(body) : url);
      if (method === 'POST') {
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      }
      if (headers) {
        Object.keys(headers).forEach(key => xhr.setRequestHeader(key, headers[key]));
      }
      if (withCredentials) {
        xhr.withCredentials = true;
      }
      xhr.onerror = xhr.onload = () => {
        let response = xhr.response;
        if (!rawResponse) {
          try {
            response = JSON.parse(response);
          } catch (e) {
            console.error(e);
          }
        }
        let responseHeaders = responseHeadersToGet ? responseHeadersToGet.reduce((headerValuePairs, headerName) => {
          headerValuePairs[headerName] = xhr.getResponseHeader(headerName);
          return headerValuePairs;
        }, {}) : null;
        if (xhr.status >= 200 && xhr.status < 300) {
          let resolveData;
          if (responseHeaders && Object.keys(responseHeaders).length) {
            resolveData = {
              response,
              responseHeaders
            };
          } else {
            resolveData = response;
          }
          resolve(resolveData);
        } else {
          let rejectData = {
            ...response,
            responseStatusCode: xhr.status
          };
          if (responseHeaders && Object.keys(responseHeaders).length) {
            rejectData = {
              ...rejectData,
              responseHeaders
            };
          }
          reject(rejectData);
        }
      };
      if (method === 'GET') {
        xhr.send();
      } else if (method === 'POST') {
        xhr.send(JSON.stringify(body));
      }
    });
  },
  createQueryString(params) {
    let keys = Object.keys(params);
    if (!keys.length) {
      return '';
    }
    return '?' + keys.filter(key => params[key]).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
  },
  deepExtend(out = {}, ...rest) {
    for (let i = 0; i < rest.length; i++) {
      let obj = rest[i];
      if (!obj) {
        continue;
      }
      for (let key in obj) {
        if (Object.hasOwn(obj, key)) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            if (obj[key] instanceof Array) {
              out[key] = obj[key].slice(0);
            } else {
              out[key] = this.deepExtend(out[key], obj[key]);
            }
          } else {
            out[key] = obj[key];
          }
        }
      }
    }
    return out;
  },
  onDocumentReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  },
  optimizeSrc(url, github) {
    let {
      newHost,
      hosts
    } = optimizedHosts;
    let base = github ? `https://cdn.jsdelivr.net/gh/${github.user}/${github.project}@${github.head}/` : typeof location !== 'undefined' ? location.href : undefined;
    let parsed = new URL(url.replace(/^\/+/, ''), base);
    if (hosts.includes(parsed.hostname)) {
      parsed.pathname = parsed.hostname + parsed.pathname;
      parsed.hostname = newHost;
    }
    return parsed.toString();
  },
  normalizeHref(url, idPrefix) {
    try {
      let parsed = new URL(url.replace(/^\/+/, ''), location.href);
      if (parsed.origin === location.origin && parsed.pathname === location.pathname) {
        if (parsed.hash) {
          parsed.hash = `#${idPrefix}${parsed.hash.substr(1)}`;
        }
      }
      return parsed.toString();
    } catch {
      return url;
    }
  },
  isExternalLink(url) {
    try {
      let parsed = new URL(url.replace(/^\/+/, ''), location.href);
      return parsed.hostname !== location.hostname;
    } catch {
      return false;
    }
  },
  getGpProbeLastTiming(testType, result) {
    let lastTiming;
    let {
      timings = []
    } = result;
    if (testType === 'ping') {
      lastTiming = timings[timings.length - 1] ? timings[timings.length - 1].rtt : PROBE_NO_TIMING_VALUE;
    }
    return lastTiming;
  },
  getGpTargetTiming(targetData) {
    if (!targetData) {
      return null;
    }
    let {
      avgTiming,
      isFailed,
      isOffline,
      areTimingsReady
    } = targetData;
    if (isFailed) {
      return PROBE_STATUS_FAILED;
    } else if (isOffline) {
      return PROBE_STATUS_OFFLINE;
    } else if (typeof avgTiming === 'number') {
      return `${Math.round(avgTiming)} ms`;
    } else if (areTimingsReady) {
      return avgTiming;
    }
    return null;
  },
  calcGpTestResTiming(testType, testResData, dnsTraceEnabled = false, units = ' ms') {
    let resTiming;
    let lastTiming;
    let extraValues = {};
    let lowCaseTestName = testType.toLowerCase();
    lastTiming = this.getGpProbeLastTiming(testType, testResData.result);
    if (testResData.result?.status === PROBE_STATUS_FAILED) {
      return {
        value: PROBE_STATUS_FAILED,
        extraValues,
        fullText: PROBE_STATUS_FAILED,
        isFailed: true
      };
    } else if (testResData.result?.status === PROBE_STATUS_OFFLINE) {
      return {
        value: PROBE_STATUS_OFFLINE,
        extraValues,
        fullText: PROBE_STATUS_OFFLINE,
        isFailed: false
      };
    }
    if (lowCaseTestName === 'ping') {
      resTiming = testResData.result?.stats?.avg;
      if (typeof testResData.result?.stats?.loss === 'number') {
        extraValues.loss = {
          text: 'Loss',
          value: testResData.result?.stats?.loss,
          units: '%'
        };
      }
    } else if (lowCaseTestName === 'traceroute') {
      let {
        timings
      } = testResData.result.hops ? testResData.result.hops[testResData.result.hops.length - 1] : {};
      extraValues.hops = {
        text: 'Hops',
        value: testResData.result.hops?.length ?? 0,
        units: ''
      };
      if (timings && timings.length) {
        let timingsCalc = timings.reduce((res, timing) => {
          if (typeof timing.rtt === 'number') {
            return {
              sum: res.sum + Number(timing.rtt),
              cnt: res.cnt + 1
            };
          }
          return res;
        }, {
          sum: 0,
          cnt: 0
        });
        if (timingsCalc.cnt) {
          resTiming = Number((timingsCalc.sum / timingsCalc.cnt).toFixed(3));
        }
      }
    } else if (lowCaseTestName === 'dns') {
      let dnsResult = testResData.result;
      if (dnsTraceEnabled) {
        let lastHop = testResData.result.hops ? testResData.result.hops[testResData.result.hops.length - 1] : {};
        if (lastHop) {
          resTiming = lastHop.timings.total;
          dnsResult = lastHop;
        }
      } else {
        resTiming = testResData.result.timings.total;
      }
      let answersCount = dnsResult.answers?.length ?? 0;
      let dnsStatus = dnsResult.statusCodeName ?? dnsResult.statusCode;
      extraValues.answers = {
        text: 'Answers',
        value: answersCount,
        units: ''
      };
      if (dnsStatus !== null && typeof dnsStatus !== 'undefined') {
        extraValues.dnsStatus = {
          text: dnsResult.statusCodeName ? '' : 'Status',
          value: dnsStatus,
          units: ''
        };
      }
      if (typeof dnsStatus !== 'undefined' && dnsStatus !== 'NOERROR' || answersCount === 0) {
        extraValues.errorStatus = PROBE_STATUS_DNS_ERROR;
      }
    } else if (lowCaseTestName === 'mtr') {
      let lastHop = testResData.result.hops ? testResData.result.hops[testResData.result.hops.length - 1] : {};
      extraValues.hops = {
        text: 'Hops',
        value: testResData.result.hops?.length ?? 0,
        units: ''
      };
      if (lastHop) {
        resTiming = lastHop.stats.avg;
      }
    } else if (lowCaseTestName === 'http') {
      if (typeof testResData.result.statusCode === 'number') {
        resTiming = testResData.result?.timings?.total;
        extraValues.httpStatus = {
          text: 'HTTP',
          value: testResData.result.statusCode,
          units: ''
        };
        if (testResData.result.statusCode >= 400) {
          extraValues.errorStatus = PROBE_STATUS_HTTP_ERROR;
        }
        if (typeof testResData.result?.timings?.dns === 'number') {
          extraValues.dns = {
            text: 'DNS',
            value: testResData.result.timings.dns,
            units: ' ms'
          };
        }
        if (typeof testResData.result?.timings?.tcp === 'number') {
          extraValues.tcp = {
            text: 'TCP',
            value: testResData.result.timings.tcp,
            units: ' ms'
          };
        }
        if (typeof testResData.result?.timings?.tls === 'number') {
          extraValues.tls = {
            text: 'TLS',
            value: testResData.result.timings.tls,
            units: ' ms'
          };
        }
        if (typeof testResData.result?.timings?.firstByte === 'number') {
          extraValues.firstByte = {
            text: 'TTFB',
            value: testResData.result.timings.firstByte,
            units: ' ms'
          };
        }
        if (typeof testResData.result?.timings?.download === 'number') {
          extraValues.download = {
            text: 'Download',
            value: testResData.result.timings.download,
            units: ' ms'
          };
        }
      }
    }
    if (typeof resTiming === 'number') {
      let note = '';
      switch (lowCaseTestName) {
        case 'traceroute':
        case 'mtr':
          note = '(average)';
          break;
        case 'dns':
        case 'http':
          note = '(total)';
          break;
      }
      return {
        value: resTiming,
        extraValues,
        units,
        note,
        fullText: note ? `${Math.round(resTiming)}${units} ${note}` : `${Math.round(resTiming)}${units}`,
        lastTiming
      };
    }
    return {
      value: PROBE_NO_TIMING_VALUE,
      extraValues,
      fullText: PROBE_NO_TIMING_VALUE,
      isFailed: testResData.result?.status === PROBE_STATUS_FAILED,
      lastTiming: PROBE_NO_TIMING_VALUE
    };
  },
  getProbeTimeOutValue() {
    return PROBE_NO_TIMING_VALUE;
  },
  getProbeStatusFailedValue() {
    return PROBE_STATUS_FAILED;
  },
  getProbeStatusOfflineValue() {
    return PROBE_STATUS_OFFLINE;
  },
  getProbeStatusDnsErrorValue() {
    return PROBE_STATUS_DNS_ERROR;
  },
  getProbeStatusHttpErrorValue() {
    return PROBE_STATUS_HTTP_ERROR;
  },
  capitalizeFirstLetter(word) {
    return word ? word[0].toUpperCase() + word.slice(1) : '';
  },
  capitalizeStrEveryFirstLetter(string, exclude = []) {
    return string.split(' ').reduce((res, w) => {
      if (exclude.includes(w)) {
        res.push(w);
      } else {
        res.push(this.capitalizeFirstLetter(w));
      }
      return res;
    }, []).join(' ');
  },
  removeDuplicatedTargets(arr) {
    return arr.reduce((uniquesArr, item) => {
      if (uniquesArr.indexOf(item) < 0) {
        uniquesArr.push(item);
      }
      return uniquesArr;
    }, []);
  },
  parseGpRawOutputForTimings(raw) {
    let packets = [];
    let timeMatch, noAnswerMatch;
    let timeRegex = /(?:icmp_seq|tcp_conn)=(\d+).*time=(\d+(\.\d+)?)/;
    let noAnswerRegex = /(?:no answer yet for|No reply from)*(?:icmp_seq|tcp_conn)=(\d+)/;
    let lines = raw.split('\n').filter(l => l);
    for (let i = 0; i < lines.length; i++) {
      if (i === 0) {
        continue;
      }
      if (lines[i].includes('---')) {
        break;
      }
      timeMatch = timeRegex.exec(lines[i]);
      noAnswerMatch = noAnswerRegex.exec(lines[i]);
      if (timeMatch) {
        packets[timeMatch[1] - 1] = parseFloat(timeMatch[2]);
      } else if (noAnswerMatch) {
        if (!packets[noAnswerMatch[1] - 1]) {
          packets[noAnswerMatch[1] - 1] = PROBE_NO_TIMING_VALUE;
        }
      } else ;
    }
    return {
      packetsRtt: packets,
      packetsDrop: packets.filter(p => p === PROBE_NO_TIMING_VALUE).length,
      packetsTotal: packets.length
    };
  },
  memoize(func) {
    let cache = new Map();
    return function (...args) {
      let key = JSON.stringify(args);
      if (!cache.has(key)) {
        cache.set(key, func.apply(this, args));
      }
      return cache.get(key);
    };
  },
  getGpProbeStatusColor(timing, probesMaxTiming = 200, probesMinTiming = 5) {
    // return default GREY color while probe has no timing yet
    if (typeof timing === 'undefined' || timing === null) {
      return '#c0c0c0';
    }

    // return default color for timed out probe
    if (timing === PROBE_NO_TIMING_VALUE || timing === PROBE_STATUS_FAILED || timing === PROBE_STATUS_OFFLINE) {
      return '#17233A';
    }
    if (timing === PROBE_STATUS_DNS_ERROR || timing === PROBE_STATUS_HTTP_ERROR) {
      return PROBE_STATUS_ERROR_COLOR;
    }
    function getColorFromGradient(quotient, start, middle, end) {
      return quotient >= 0.5 ? linear(middle, end, (quotient - 0.5) * 2) : linear(start, middle, quotient * 2);
    }
    function linear(startColor, endColor, quotient) {
      let redColor = byteLinear(startColor[1] + startColor[2], endColor[1] + endColor[2], quotient);
      let greenColor = byteLinear(startColor[3] + startColor[4], endColor[3] + endColor[4], quotient);
      let blueColor = byteLinear(startColor[5] + startColor[6], endColor[5] + endColor[6], quotient);
      return `#${redColor}${greenColor}${blueColor}`;
    }
    function byteLinear(partOne, partTwo, quotient) {
      let color = Math.floor(('0x' + partOne) * (1 - quotient) + ('0x' + partTwo) * quotient);
      return color.toString(16).padStart(2, '0');
    }
    let pureTimingValue = parseInt(timing);

    // '#17d4a7', '#ffb800', '#e64e3d' - colors are used for timings scale on the map
    if (pureTimingValue <= probesMinTiming) {
      return '#17d4a7';
    }
    if (pureTimingValue >= probesMaxTiming) {
      return '#e64e3d';
    }
    return getColorFromGradient(pureTimingValue / probesMaxTiming, '#17d4a7', '#ffb800', '#e64e3d');
  },
  pluralize(singular, countOrPlural, countOrUndefined) {
    let count = typeof countOrPlural === 'string' ? countOrUndefined : countOrPlural;
    let plural = typeof countOrPlural === 'string' ? countOrPlural : singular + 's';
    return count === 1 ? singular : plural;
  },
  createMeasCreditsErrMsg(responseHeaders, hasToken = false, isInfinite = false, hasResults = false, isSecondTarget = false, primaryTarget = '') {
    // do not show err msg if we get a 429 and have results for infinite measurement
    if (hasResults && isInfinite) {
      return null;
    }
    if (hasResults && isSecondTarget && primaryTarget) {
      return `Not enough credits to test both targets, showing results for ${primaryTarget} only. You can get higher limits by creating an account.`;
    }
    let minutes = responseHeaders['x-ratelimit-reset'] / 60;
    let timeToReset = minutes < 1 ? '< 1 minute' : `${Math.ceil(minutes)} minutes`;
    let remainingCredits = Number(responseHeaders['x-ratelimit-remaining'] || 0) + Number(responseHeaders['x-credits-remaining'] || 0);
    let requiredCredits = Number(responseHeaders['x-request-cost'] || 0);
    if (isInfinite === false && remainingCredits) {
      let msg = `<span>You only have ${remainingCredits} credits remaining, and ${requiredCredits} were required.</span>`;
      msg += `<span>Try requesting fewer probes or wait ${timeToReset} for the limit to reset.</span>`;
      if (hasToken) {
        msg += '<span>You can get higher limits by sponsoring us or hosting probes</span>';
      } else {
        msg += '<span>You can get higher limits by creating an account. <a href="https://dash.globalping.io">Sign up</a><span>';
      }
      return msg;
    } else if (isInfinite && !hasResults || !remainingCredits) {
      let msg = `<span>You have run out of credits for this session.</span>`;
      msg += `<span>You can wait ${timeToReset} for the limit to reset or get higher limits by`;
      if (hasToken) {
        msg += ` sponsoring us or hosting probes.</span>`;
      } else {
        msg += ` creating an account. <a href='https://dash.globalping.io'>Sign up</a></span>`;
      }
      return msg;
    }
    return 'All tests failed. Maybe you specified a non-existing endpoint?';
  },
  parseValidationErrors(errorBody, target = '') {
    let prefix = target ? `${target}: ` : '';
    return Object.keys(errorBody.params || {}).reduce((res, key) => {
      let fieldName = key.split('.')[key.split('.').length - 1];
      if (['locations', 'magic'].includes(fieldName)) {
        fieldName = 'location';
      }
      res[fieldName] = `${prefix}${this.capitalizeFirstLetter(errorBody.params[key].replace(/".*"/, fieldName))}`;
      return res;
    }, {});
  },
  sortGpMeasurementResults(results, by, order, targetIdx) {
    let sortCoeff = order === 'desc' ? -1 : 1;
    let sortToFieldMap = {
      'avg': 'avgTiming',
      'max': 'maxTiming',
      'min': 'minTiming',
      'rtt-last': 'lastTiming'
    };
    let getLocationStr = loc => {
      return `${loc.city}${loc.country}${loc.continent}${loc.network}`;
    };
    let getFieldVal = (loc, field) => {
      let value = loc.statsPerTarget[targetIdx][field];
      if (typeof value !== 'number' || Number.isNaN(value)) {
        return Infinity;
      }
      return value;
    };
    switch (by) {
      case 'location':
        {
          return results.toSorted((a, b) => sortCoeff * getLocationStr(a).localeCompare(getLocationStr(b)));
        }
      case 'quality':
        {
          return results.toSorted((a, b) => {
            let totalLhs = getFieldVal(a, 'statsTotal');
            let totalRhs = getFieldVal(b, 'statsTotal');
            if (totalLhs === 0 || totalRhs === 0) {
              return 0;
            }
            return -sortCoeff * (getFieldVal(a, 'statsDrop') / totalLhs - getFieldVal(b, 'statsDrop') / totalRhs);
          });
        }
      default:
        {
          if (!Object.hasOwn(sortToFieldMap, by)) {
            return results;
          }
          return results.toSorted((a, b) => sortCoeff * (getFieldVal(a, sortToFieldMap[by]) - getFieldVal(b, sortToFieldMap[by])));
        }
    }
  },
  isTagCloudRegion(tag) {
    return /^(gcp|aws|azure|oci)-\S+/.test(tag);
  },
  injectGlobalStyle(href) {
    if (typeof document === 'undefined') {
      return;
    }
    for (let link of document.getElementsByTagName('link')) {
      if (link.href === href) {
        return;
      }
    }
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  },
  networkNameToKey(network) {
    return network.replace(/\./g, '').replace(/[\W]|_/g, ' ').replace(/\s\s+|_/g, ' ').trim().split(' ').join('-').toLowerCase();
  },
  clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  },
  createLocationString(newLocation, locationFilter) {
    let targetLoc;
    let locations = locationFilter.replace(/^world$/i, '').split(',').map(location => location.trim()).filter(Boolean);
    if (!locations.length) {
      targetLoc = newLocation;
    } else {
      targetLoc = locations.reduce((shortestLoc, location) => {
        let filteredParts = location.split(/[+%]/).map(part => part.trim()).filter(part => {
          let countryCode = COUNTRIES_MAP[part];
          let countryName = COUNTRY_CODE_MAP[part];
          let isRedundant = newLocation.includes(part) || countryCode && newLocation.includes(countryCode) || countryName && newLocation.includes(countryName);
          return !isRedundant;
        });
        let candidateLoc = [newLocation, ...filteredParts].join('+');
        return !shortestLoc || candidateLoc.length < shortestLoc.length ? candidateLoc : shortestLoc;
      }, '');
    }
    return targetLoc;
  },
  escapeLocationString(location) {
    return location.replace(/[%&<>"']/g, ch => ({
      '%': '+',
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;'
    })[ch]);
  },
  numericalFieldWidth(value, minWidth = 1) {
    let optimalWidth = Math.floor(Math.log10(Math.abs(value))) + (value < 0 ? 1 : 0) + 1;
    return Math.max(optimalWidth, minWidth);
  },
  isTouchDevice() {
    return !!window?.matchMedia('(hover: none), (pointer: coarse)')?.matches;
  },
  isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  },
  shouldCollapseResponseBody(body, charsPerLine) {
    if (!body) {
      return false;
    }
    let lines = String(body).split('\n');
    if (lines.length > 3) {
      return true;
    }
    return lines.slice(0, 3).reduce((acc, line) => acc + Math.ceil(line.length / charsPerLine), 0) > 3;
  },
  isEqual(obj1, obj2) {
    if (Object.is(obj1, obj2)) {
      return true;
    }
    if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
      return false;
    }
    let isArray1 = Array.isArray(obj1);
    let isArray2 = Array.isArray(obj2);
    if (isArray1 || isArray2) {
      if (!isArray1 || !isArray2 || obj1.length !== obj2.length) {
        return false;
      }
      for (let i = 0; i < obj1.length; i++) {
        if (!this.isEqual(obj1[i], obj2[i])) {
          return false;
        }
      }
      return true;
    }
    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (let key of keys1) {
      if (!Object.hasOwn(obj2, key) || !this.isEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  }
};

var component$7 = {
  exports: {}
};
component$7.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "div",
    m: [{
      t: 13,
      n: "class",
      f: "c-header-gradient",
      g: 1
    }],
    f: [{
      t: 7,
      e: "img",
      m: [{
        t: 13,
        n: "class",
        f: "header-gradient_primary",
        g: 1
      }, {
        n: "fetchpriority",
        f: "high",
        t: 13,
        g: 1
      }, {
        n: "width",
        f: "1440",
        t: 13,
        g: 1
      }, {
        n: "height",
        f: "684",
        t: 13,
        g: 1
      }, {
        n: "src",
        f: [{
          t: 2,
          r: "@shared.assetsHost"
        }, "/img/about/about-gradient.jpg"],
        t: 13
      }]
    }, " ", {
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "header-gradient_secondary",
        g: 1
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "header-gradient_map",
          g: 1
        }]
      }],
      n: 50,
      r: "showMap"
    }]
  }]
};
var headerGradient = ractive.extend(component$7.exports);

var has = {
  localStorage() {
    try {
      localStorage.setItem('localStorageTest', 1);
      localStorage.removeItem('localStorageTest');
    } catch {
      return false;
    }
    return true;
  },
  sessionStorage() {
    try {
      sessionStorage.setItem('sessionStorageTest', 1);
      sessionStorage.removeItem('sessionStorageTest');
    } catch {
      return false;
    }
    return true;
  }
};

var component$6 = {
  exports: {}
};
const notificationKey = 'job-1-notificationSeen';
component$6.exports = {
  data() {
    return {
      notificationSeen: true
    };
  },
  oninit() {
    if (ractive.isServer) {
      this.set('notificationSeen', true);
    } else {
      if (has.localStorage()) {
        if (localStorage.getItem(notificationKey)) {
          this.set('notificationSeen', true);
        }
        this.observe('notificationSeen', newValue => {
          localStorage.setItem(notificationKey, JSON.stringify(newValue));
        }, {
          init: false
        });
      }

      // this.observe('notificationSeen', (newValue) => {
      // 	document.body.classList[newValue ? 'remove' : 'add']('c-notification-visible');
      // });
    }
  }
};
component$6.exports.template = {
  v: 4,
  t: [{
    t: 4,
    f: [{
      t: 7,
      e: "div",
      m: [{
        t: 13,
        n: "class",
        f: "c-notification",
        g: 1
      }],
      f: [{
        t: 7,
        e: "i",
        m: [{
          t: 13,
          n: "class",
          f: "fa fa-bullhorn",
          g: 1
        }, {
          n: "aria-hidden",
          f: "true",
          t: 13,
          g: 1
        }]
      }, " ", {
        t: 7,
        e: "a",
        m: [{
          n: "href",
          f: "https://gist.github.com/jimaek/de24cee25048de8bbe3f0d811695cdf7",
          t: 13,
          g: 1
        }, {
          n: "target",
          f: "_blank",
          t: 13,
          g: 1
        }],
        f: ["We're looking for a Senior Node.js Engineer to help expand our open-source projects!"]
      }, " ", {
        t: 7,
        e: "a",
        m: [{
          n: ["click"],
          t: 70,
          f: {
            r: ["@this"],
            s: "[_0.set(\"notificationSeen\",true)]"
          }
        }, {
          n: "aria-label",
          f: "Close",
          t: 13,
          g: 1
        }],
        f: [{
          t: 7,
          e: "i",
          m: [{
            t: 13,
            n: "class",
            f: "fa fa-times",
            g: 1
          }, {
            n: "aria-hidden",
            f: "true",
            t: 13,
            g: 1
          }]
        }]
      }]
    }],
    n: 50,
    x: {
      r: ["notificationSeen"],
      s: "!_0"
    }
  }],
  e: {
    "[_0.set(\"notificationSeen\",true)]": function (_0) {
      return [_0.set("notificationSeen", true)];
    },
    "!_0": function (_0) {
      return !_0;
    }
  }
};
var notification = ractive.extend(component$6.exports);

var component$5 = {
  exports: {}
};
component$5.exports = {
  data() {
    return {
      class: '',
      top: '0',
      size: '',
      src: ''
    };
  }
};
component$5.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "span",
    m: [{
      t: 13,
      n: "class",
      f: "c-dropdown-icon",
      g: 1
    }],
    f: [{
      t: 4,
      f: [{
        t: 7,
        e: "i",
        m: [{
          n: "class",
          f: [{
            t: 2,
            r: "class"
          }],
          t: 13
        }, {
          n: "aria-hidden",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "style-font-size",
          f: [{
            t: 2,
            r: "size"
          }],
          t: 13
        }, {
          n: "style-margin-top",
          f: [{
            t: 2,
            r: "top"
          }],
          t: 13
        }]
      }],
      n: 50,
      r: "class"
    }, {
      t: 4,
      f: [{
        t: 7,
        e: "img",
        m: [{
          n: "src",
          f: [{
            t: 2,
            r: "src"
          }],
          t: 13
        }, {
          n: "style-width",
          f: [{
            t: 2,
            r: "size"
          }],
          t: 13
        }, {
          n: "style-margin-top",
          f: [{
            t: 2,
            r: "top"
          }, ";"],
          t: 13
        }, {
          n: "alt",
          f: "",
          t: 13,
          g: 1
        }]
      }],
      n: 50,
      r: "src",
      l: 1
    }]
  }]
};
var dropdownIcon = ractive.extend(component$5.exports);

var component$4 = {
  exports: {}
};
component$4.exports = {
  data() {
    return {};
  }
};
component$4.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "header",
    m: [{
      n: "class",
      f: ["c-header ", {
        t: 4,
        f: [{
          t: 2,
          r: "additionalClasses"
        }],
        n: 50,
        r: "additionalClasses"
      }],
      t: 13
    }, {
      n: "inert",
      f: [{
        t: 2,
        r: "isInert"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "nav",
      m: [{
        t: 13,
        n: "class",
        f: "navbar navbar-default navbar-filled",
        g: 1
      }],
      f: [{
        t: 7,
        e: "div",
        m: [{
          t: 13,
          n: "class",
          f: "container-fluid container-mw",
          g: 1
        }],
        f: [{
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "navbar-header",
            g: 1
          }],
          f: [{
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "main-logo",
              g: 1
            }, {
              n: "href",
              f: "/",
              t: 13,
              g: 1
            }, {
              n: ["click"],
              t: 70,
              f: {
                r: ["@this"],
                s: "[_0.fire(\"main-logo-click\")]"
              }
            }],
            f: [{
              t: 9,
              c: "\n\t\t\t\t\t\tLooking for the logo?\n\t\t\t\t\t\tGet all versions here: https://github.com/jsdelivr/globalping-media\n\t\t\t\t\t"
            }, " ", {
              t: 4,
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "138",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "34",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/", {
                    t: 2,
                    r: "mainLogoName"
                  }],
                  t: 13
                }, {
                  n: "title",
                  f: "Globalping",
                  t: 13,
                  g: 1
                }]
              }],
              n: 50,
              r: "mainLogoName"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "img",
                m: [{
                  n: "width",
                  f: "138",
                  t: 13,
                  g: 1
                }, {
                  n: "height",
                  f: "34",
                  t: 13,
                  g: 1
                }, {
                  n: "src",
                  f: [{
                    t: 2,
                    r: "@shared.assetsHost"
                  }, "/img/globalping.svg"],
                  t: 13
                }, {
                  n: "title",
                  f: "Globalping",
                  t: 13,
                  g: 1
                }]
              }],
              n: 51,
              l: 1
            }]
          }, " ", {
            t: 7,
            e: "a",
            m: [{
              t: 13,
              n: "class",
              f: "main-logo_text globalping",
              g: 1
            }, {
              n: "href",
              f: "https://www.jsdelivr.com",
              t: 13,
              g: 1
            }],
            f: ["by jsDelivr"]
          }, " ", {
            t: 7,
            e: "button",
            m: [{
              t: 13,
              n: "class",
              f: "navbar-toggle collapsed",
              g: 1
            }, {
              n: "type",
              f: "button",
              t: 13,
              g: 1
            }, {
              n: "data-toggle",
              f: "collapse",
              t: 13,
              g: 1
            }, {
              n: "data-target",
              f: "#main-navbar",
              t: 13,
              g: 1
            }, {
              n: "aria-expanded",
              f: "false",
              t: 13,
              g: 1
            }],
            f: [{
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "sr-only",
                g: 1
              }],
              f: ["Toggle navigation"]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "icon-bar",
                g: 1
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "icon-bar",
                g: 1
              }]
            }, " ", {
              t: 7,
              e: "span",
              m: [{
                t: 13,
                n: "class",
                f: "icon-bar",
                g: 1
              }]
            }]
          }]
        }, " ", {
          t: 7,
          e: "div",
          m: [{
            t: 13,
            n: "class",
            f: "collapse navbar-collapse",
            g: 1
          }, {
            n: "id",
            f: "main-navbar",
            t: 13,
            g: 1
          }],
          f: [{
            t: 7,
            e: "ul",
            m: [{
              n: "class",
              f: ["nav navbar-nav navbar-right ", {
                t: 2,
                x: {
                  r: ["@shared.actualPath"],
                  s: "!_0?\"navbar-hidden\":\"about-navbar-right\""
                }
              }],
              t: 13
            }],
            f: [{
              t: 7,
              e: "li",
              f: [{
                t: 7,
                e: "a",
                m: [{
                  n: "href",
                  f: "/cli",
                  t: 13,
                  g: 1
                }],
                f: ["CLI"]
              }]
            }, " ", {
              t: 7,
              e: "li",
              m: [{
                t: 13,
                n: "class",
                f: "dropdown",
                g: 1
              }],
              f: [{
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-toggle",
                  g: 1
                }, {
                  n: "data-toggle",
                  f: "dropdown",
                  t: 13,
                  g: 1
                }, {
                  n: "role",
                  f: "button",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-haspopup",
                  f: "true",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-expanded",
                  f: "false",
                  t: 13,
                  g: 1
                }, {
                  n: "tabindex",
                  f: "0",
                  t: 13,
                  g: 1
                }],
                f: ["Integrations ", {
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-angle-down",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }]
              }, " ", {
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-menu",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/slack",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/slack-icon-dark.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }]
                    }, "Slack App"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/discord",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/discord-icon-dark.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }, {
                        n: "top",
                        f: "1px",
                        t: 13,
                        g: 1
                      }]
                    }, "Discord App"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "router-ignore",
                      g: 1
                    }, {
                      n: "href",
                      f: "/docs/api.globalping.io",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/code-icon-dark.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }]
                    }, "REST API"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "divider",
                    g: 1
                  }, {
                    n: "role",
                    f: "separator",
                    t: 13,
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/integrations",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/list-icon-dark.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }]
                    }, "All Integrations"]
                  }]
                }]
              }]
            }, " ", {
              t: 7,
              e: "li",
              f: [{
                t: 7,
                e: "a",
                m: [{
                  n: "href",
                  f: "/credits",
                  t: 13,
                  g: 1
                }],
                f: ["Credits"]
              }]
            }, " ", {
              t: 7,
              e: "li",
              m: [{
                t: 13,
                n: "class",
                f: "dropdown",
                g: 1
              }],
              f: [{
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-toggle",
                  g: 1
                }, {
                  n: "data-toggle",
                  f: "dropdown",
                  t: 13,
                  g: 1
                }, {
                  n: "role",
                  f: "button",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-haspopup",
                  f: "true",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-expanded",
                  f: "false",
                  t: 13,
                  g: 1
                }, {
                  n: "tabindex",
                  f: "0",
                  t: 13,
                  g: 1
                }],
                f: ["Explore ", {
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-angle-down",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }]
              }, " ", {
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-menu",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/network",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        n: "src",
                        f: [{
                          t: 2,
                          r: "@shared.assetsHost"
                        }, "/img/radio.svg"],
                        t: 13
                      }, {
                        n: "size",
                        f: "14px",
                        t: 13,
                        g: 1
                      }]
                    }, "Probe Network"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/network-providers",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-server",
                        g: 1
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }, {
                        n: "top",
                        f: "2px",
                        t: 13,
                        g: 1
                      }]
                    }, "Network Providers"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/leaderboard",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "c-dropdown-icon",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-trophy",
                        g: 1
                      }, {
                        n: "size",
                        f: "12px",
                        t: 13,
                        g: 1
                      }, {
                        n: "top",
                        f: "1px",
                        t: 13,
                        g: 1
                      }]
                    }, "User Leaderboard"]
                  }]
                }]
              }]
            }, " ", {
              t: 7,
              e: "li",
              f: [{
                t: 7,
                e: "a",
                m: [{
                  n: "href",
                  f: "/sponsors",
                  t: 13,
                  g: 1
                }],
                f: ["Sponsors"]
              }]
            }, " ", {
              t: 7,
              e: "li",
              m: [{
                t: 13,
                n: "class",
                f: "dropdown",
                g: 1
              }],
              f: [{
                t: 7,
                e: "a",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-toggle",
                  g: 1
                }, {
                  n: "data-toggle",
                  f: "dropdown",
                  t: 13,
                  g: 1
                }, {
                  n: "role",
                  f: "button",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-haspopup",
                  f: "true",
                  t: 13,
                  g: 1
                }, {
                  n: "aria-expanded",
                  f: "false",
                  t: 13,
                  g: 1
                }, {
                  n: "tabindex",
                  f: "0",
                  t: 13,
                  g: 1
                }],
                f: ["The Project ", {
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-angle-down",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }]
              }, " ", {
                t: 7,
                e: "ul",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dropdown-menu",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      n: "href",
                      f: "/about-us",
                      t: 13,
                      g: 1
                    }],
                    f: ["About Us"]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "divider",
                    g: 1
                  }, {
                    n: "role",
                    f: "separator",
                    t: 13,
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "router-ignore",
                      g: 1
                    }, {
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: "https://blog.globalping.io",
                      t: 13,
                      g: 1
                    }],
                    f: ["Blog ", {
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-external-link",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }]
                  }]
                }, " ", {
                  t: 7,
                  e: "li",
                  f: [{
                    t: 7,
                    e: "a",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "router-ignore",
                      g: 1
                    }, {
                      n: "target",
                      f: "_blank",
                      t: 13,
                      g: 1
                    }, {
                      n: "href",
                      f: "https://github.com/jsdelivr/globalping",
                      t: 13,
                      g: 1
                    }],
                    f: ["GitHub ", {
                      t: 7,
                      e: "i",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "fa fa-external-link",
                        g: 1
                      }, {
                        n: "aria-hidden",
                        f: "true",
                        t: 13,
                        g: 1
                      }]
                    }]
                  }]
                }]
              }]
            }, " ", {
              t: 7,
              e: "li",
              f: [{
                t: 7,
                e: "a",
                m: [{
                  n: "target",
                  f: "_blank",
                  t: 13,
                  g: 1
                }, {
                  n: "rel",
                  f: "noopener noreferrer",
                  t: 13,
                  g: 1
                }, {
                  n: "href",
                  f: "https://twitter.com/jsDelivr",
                  t: 13,
                  g: 1
                }, {
                  n: "title",
                  f: "Twitter",
                  t: 13,
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "i",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "fa fa-twitter",
                    g: 1
                  }, {
                    n: "aria-hidden",
                    f: "true",
                    t: 13,
                    g: 1
                  }]
                }, " ", {
                  t: 7,
                  e: "span",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "icon-label-mobile",
                    g: 1
                  }],
                  f: ["Twitter"]
                }]
              }]
            }, " ", {
              t: 4,
              f: [{
                t: 7,
                e: "li",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dashboard-section",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "btn btn-dash",
                    g: 1
                  }, {
                    n: "href",
                    f: "https://dash.globalping.io",
                    t: 13,
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "svg",
                    m: [{
                      t: 13,
                      n: "style",
                      f: "margin-right: 8px;",
                      g: 1
                    }, {
                      n: "width",
                      f: "14",
                      t: 13,
                      g: 1
                    }, {
                      n: "height",
                      f: "14",
                      t: 13,
                      g: 1
                    }, {
                      n: "viewBox",
                      f: "0 0 20 20",
                      t: 13,
                      g: 1
                    }, {
                      n: "fill",
                      f: "none",
                      t: 13,
                      g: 1
                    }, {
                      n: "stroke",
                      f: "currentColor",
                      t: 13,
                      g: 1
                    }, {
                      n: "xmlns",
                      f: "http://www.w3.org/2000/svg",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "path",
                      m: [{
                        n: "d",
                        f: "M8.33333 2.5H2.5V8.33333H8.33333V2.5Z",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-width",
                        f: "2",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linecap",
                        f: "round",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linejoin",
                        f: "round",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "path",
                      m: [{
                        n: "d",
                        f: "M17.5 2.5H11.6667V8.33333H17.5V2.5Z",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-width",
                        f: "2",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linecap",
                        f: "round",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linejoin",
                        f: "round",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "path",
                      m: [{
                        n: "d",
                        f: "M17.5 11.6667H11.6667V17.5001H17.5V11.6667Z",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-width",
                        f: "2",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linecap",
                        f: "round",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linejoin",
                        f: "round",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "path",
                      m: [{
                        n: "d",
                        f: "M8.33333 11.6667H2.5V17.5001H8.33333V11.6667Z",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-width",
                        f: "2",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linecap",
                        f: "round",
                        t: 13,
                        g: 1
                      }, {
                        n: "stroke-linejoin",
                        f: "round",
                        t: 13,
                        g: 1
                      }]
                    }]
                  }, " Dashboard"]
                }, " ", {
                  t: 7,
                  e: "div",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "dropdown",
                    g: 1
                  }],
                  f: [{
                    t: 7,
                    e: "button",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "btn dropdown-toggle hidden-xs hidden-sm",
                      g: 1
                    }, {
                      n: "type",
                      f: "button",
                      t: 13,
                      g: 1
                    }, {
                      n: "data-toggle",
                      f: "dropdown",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-haspopup",
                      f: "true",
                      t: 13,
                      g: 1
                    }, {
                      n: "aria-expanded",
                      f: "false",
                      t: 13,
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "svg",
                      m: [{
                        t: 13,
                        n: "style",
                        f: "vertical-align: middle;",
                        g: 1
                      }, {
                        n: "fill",
                        f: "currentColor",
                        t: 13,
                        g: 1
                      }, {
                        n: "width",
                        f: "20px",
                        t: 13,
                        g: 1
                      }, {
                        n: "height",
                        f: "20px",
                        t: 13,
                        g: 1
                      }, {
                        n: "xmlns",
                        f: "http://www.w3.org/2000/svg",
                        t: 13,
                        g: 1
                      }, {
                        n: "viewBox",
                        f: "0 0 24 24",
                        t: 13,
                        g: 1
                      }],
                      f: [{
                        t: 7,
                        e: "g",
                        m: [{
                          n: "id",
                          f: "user",
                          t: 13,
                          g: 1
                        }],
                        f: [{
                          t: 7,
                          e: "path",
                          m: [{
                            n: "d",
                            f: "M12,12.25A3.75,3.75,0,1,1,15.75,8.5,3.75,3.75,0,0,1,12,12.25Zm0-6A2.25,2.25,0,1,0,14.25,8.5,2.25,2.25,0,0,0,12,6.25Z",
                            t: 13,
                            g: 1
                          }]
                        }, " ", {
                          t: 7,
                          e: "path",
                          m: [{
                            n: "d",
                            f: "M19,19.25a.76.76,0,0,1-.75-.75c0-1.95-1.06-3.25-6.25-3.25s-6.25,1.3-6.25,3.25a.75.75,0,0,1-1.5,0c0-4.75,5.43-4.75,7.75-4.75s7.75,0,7.75,4.75A.76.76,0,0,1,19,19.25Z",
                            t: 13,
                            g: 1
                          }]
                        }]
                      }]
                    }, " ", {
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "caret",
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "span",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "sr-only",
                        g: 1
                      }],
                      f: ["Toggle Dropdown"]
                    }]
                  }, " ", {
                    t: 7,
                    e: "ul",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "dropdown-menu",
                      g: 1
                    }],
                    f: [{
                      t: 7,
                      e: "li",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "current-user",
                        g: 1
                      }],
                      f: [{
                        t: 2,
                        r: "@shared.user.github_username"
                      }]
                    }, " ", {
                      t: 7,
                      e: "li",
                      m: [{
                        t: 13,
                        n: "class",
                        f: "divider",
                        g: 1
                      }, {
                        n: "role",
                        f: "separator",
                        t: 13,
                        g: 1
                      }]
                    }, " ", {
                      t: 7,
                      e: "li",
                      f: [{
                        t: 7,
                        e: "a",
                        m: [{
                          n: ["click"],
                          t: 70,
                          f: {
                            r: ["@global.app"],
                            s: "[_0.signOut()]"
                          }
                        }],
                        f: ["Sign Out"]
                      }]
                    }]
                  }]
                }]
              }, " ", {
                t: 7,
                e: "li",
                m: [{
                  t: 13,
                  n: "class",
                  f: "hidden-md hidden-lg",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    n: ["click"],
                    t: 70,
                    f: {
                      r: ["@global.app"],
                      s: "[_0.signOut()]"
                    }
                  }],
                  f: [{
                    t: 7,
                    e: "i",
                    m: [{
                      t: 13,
                      n: "style",
                      f: "margin-right: 8px;",
                      g: 1
                    }, {
                      t: 13,
                      n: "class",
                      f: "fa fa-sign-out",
                      g: 1
                    }]
                  }, "Sign Out"]
                }]
              }],
              n: 50,
              r: "@shared.user"
            }, {
              t: 4,
              f: [{
                t: 7,
                e: "li",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dashboard-section",
                  g: 1
                }],
                f: [{
                  t: 7,
                  e: "a",
                  m: [{
                    t: 13,
                    n: "class",
                    f: "btn btn-sign-in",
                    g: 1
                  }, {
                    n: ["click"],
                    t: 70,
                    f: {
                      r: ["@global.app"],
                      s: "[_0.signIn()]"
                    }
                  }],
                  f: [{
                    t: 7,
                    e: "i",
                    m: [{
                      t: 13,
                      n: "style",
                      f: "margin-right: 8px;",
                      g: 1
                    }, {
                      t: 13,
                      n: "class",
                      f: "fa fa-sign-in hidden-md hidden-lg",
                      g: 1
                    }]
                  }, " Sign in ", {
                    t: 7,
                    e: "span",
                    m: [{
                      t: 13,
                      n: "class",
                      f: "hidden-md hidden-lg",
                      g: 1
                    }],
                    f: [" with GitHub"]
                  }, {
                    t: 7,
                    e: "i",
                    m: [{
                      t: 13,
                      n: "style",
                      f: "margin-left: 8px;",
                      g: 1
                    }, {
                      t: 13,
                      n: "class",
                      f: "fa fa-github hidden-xs hidden-sm",
                      g: 1
                    }]
                  }]
                }]
              }, " "],
              n: 50,
              x: {
                r: ["@shared.user"],
                s: "_0===null"
              },
              l: 1
            }, {
              t: 4,
              f: [" ", {
                t: 7,
                e: "li",
                m: [{
                  t: 13,
                  n: "class",
                  f: "dashboard-section",
                  g: 1
                }]
              }],
              n: 51,
              l: 1
            }]
          }]
        }]
      }]
    }]
  }],
  e: {
    "[_0.fire(\"main-logo-click\")]": function (_0) {
      return [_0.fire("main-logo-click")];
    },
    "!_0?\"navbar-hidden\":\"about-navbar-right\"": function (_0) {
      return !_0 ? "navbar-hidden" : "about-navbar-right";
    },
    "[_0.signOut()]": function (_0) {
      return [_0.signOut()];
    },
    "[_0.signIn()]": function (_0) {
      return [_0.signIn()];
    },
    "_0===null": function (_0) {
      return _0 === null;
    }
  }
};
component$4.exports.components = {
  "c-dropdown-icon": dropdownIcon
};
var header = ractive.extend(component$4.exports);

var component$3 = {
  exports: {}
};
component$3.exports.template = {
  v: 4,
  t: [{
    t: 4,
    f: [{
      t: 7,
      e: "script",
      m: [{
        n: "type",
        f: "text/plain",
        t: 13,
        g: 1
      }, {
        n: "id",
        f: "ractive-data",
        t: 13,
        g: 1
      }],
      f: ["\t\t<<RACTIVE_SERIALIZED_DATA>>\n\t"]
    }, " ", {
      t: 7,
      e: "script",
      m: [{
        n: "type",
        f: "text/plain",
        t: 13,
        g: 1
      }, {
        n: "id",
        f: "ractive-shared",
        t: 13,
        g: 1
      }],
      f: ["\t\t", {
        t: 2,
        x: {
          r: ["@shared", "@shared.serverHost", "@shared.assetsHost", "@shared.apiDocsHost", "@shared.assetsVersion", "@shared.route", "@shared.params", "@shared.qsParams", "@shared.options"],
          s: "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))"
        }
      }, "\n\t"]
    }],
    n: 50,
    r: "@shared.isServer"
  }],
  e: {
    "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))": function (_0, _1, _2, _3, _4, _5, _6, _7, _8) {
      return _0.escape(JSON.stringify({
        serverHost: _1,
        assetsHost: _2,
        apiDocsHost: _3,
        assetsVersion: _4,
        route: _5,
        params: _6,
        qsParams: _7,
        options: _8
      }));
    }
  }
};
var rSerialize = ractive.extend(component$3.exports);

var component$2 = {
  exports: {}
};
component$2.exports = {
  data() {
    return {
      publicRoot: ''
    };
  }
};
component$2.exports.template = {
  v: 4,
  t: [{
    t: 4,
    f: [{
      t: 16
    }],
    n: 50,
    x: {
      r: ["@shared.isServer"],
      s: "!_0"
    }
  }, {
    t: 4,
    f: [{
      t: 18,
      a: " html"
    }, " ", {
      t: 7,
      e: "html",
      m: [{
        n: "lang",
        f: "en",
        t: 13,
        g: 1
      }],
      f: [{
        t: 7,
        e: "head",
        f: [{
          t: 7,
          e: "meta",
          m: [{
            n: "charset",
            f: "utf-8",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "viewport",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "width=device-width, initial-scale=1",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "description",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: [{
              t: 2,
              x: {
                r: ["description"],
                s: "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\""
              }
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "keywords",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "globalping, jsdelivr, free, open source, oss",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "property",
            f: "og:locale",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "en_US",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "property",
            f: "og:type",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "website",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "property",
            f: "og:title",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: [{
              t: 2,
              x: {
                r: ["title"],
                s: "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\""
              }
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "property",
            f: "og:description",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: [{
              t: 2,
              x: {
                r: ["description"],
                s: "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\""
              }
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "property",
            f: "og:url",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: [{
              t: 2,
              r: "@shared.serverHost"
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "property",
            f: "og:site_name",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "Globalping",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 4,
          f: [{
            t: 7,
            e: "meta",
            m: [{
              n: "property",
              f: "og:image",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: [{
                t: 2,
                r: "openGraphImage"
              }],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "meta",
            m: [{
              n: "property",
              f: "og:image:secure_url",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: [{
                t: 2,
                r: "openGraphImage"
              }],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "meta",
            m: [{
              n: "property",
              f: "og:image:width",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: "1280",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "meta",
            m: [{
              n: "property",
              f: "og:image:height",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: "640",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "meta",
            m: [{
              n: "name",
              f: "twitter:image",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: [{
                t: 2,
                r: "openGraphImage"
              }],
              t: 13
            }]
          }],
          n: 50,
          r: "openGraphImage"
        }, {
          t: 4,
          f: [{
            t: 7,
            e: "meta",
            m: [{
              n: "property",
              f: "og:image",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/og-globalping.png"],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "meta",
            m: [{
              n: "property",
              f: "og:image:secure_url",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/og-globalping.png"],
              t: 13
            }]
          }, " ", {
            t: 7,
            e: "meta",
            m: [{
              n: "property",
              f: "og:image:width",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: "1280",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "meta",
            m: [{
              n: "property",
              f: "og:image:height",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: "640",
              t: 13,
              g: 1
            }]
          }, " ", {
            t: 7,
            e: "meta",
            m: [{
              n: "name",
              f: "twitter:image",
              t: 13,
              g: 1
            }, {
              n: "content",
              f: [{
                t: 2,
                r: "@shared.assetsHost"
              }, "/img/og-globalping.png"],
              t: 13
            }]
          }],
          n: 51,
          l: 1
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "twitter:card",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "summary_large_image",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "twitter:title",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: [{
              t: 2,
              x: {
                r: ["title"],
                s: "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\""
              }
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "twitter:description",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: [{
              t: 2,
              x: {
                r: ["description"],
                s: "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\""
              }
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "twitter:site",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "@jsdelivr",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "twitter:creator",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "@jsdelivr",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "title",
          f: [{
            t: 2,
            x: {
              r: ["title"],
              s: "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\""
            }
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "icon",
            t: 13,
            g: 1
          }, {
            n: "type",
            f: "image/x-icon",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "publicRoot"
            }, "/icons/favicon.ico"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "icon",
            t: 13,
            g: 1
          }, {
            n: "type",
            f: "image/svg+xml",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "publicRoot"
            }, "/icons/favicon.svg"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "icon",
            t: 13,
            g: 1
          }, {
            n: "type",
            f: "image/png",
            t: 13,
            g: 1
          }, {
            n: "sizes",
            f: "48x48",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "publicRoot"
            }, "/icons/favicon-48x48.png"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "icon",
            t: 13,
            g: 1
          }, {
            n: "type",
            f: "image/png",
            t: 13,
            g: 1
          }, {
            n: "sizes",
            f: "32x32",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "publicRoot"
            }, "/icons/favicon-32x32.png"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "icon",
            t: 13,
            g: 1
          }, {
            n: "type",
            f: "image/png",
            t: 13,
            g: 1
          }, {
            n: "sizes",
            f: "16x16",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "publicRoot"
            }, "/icons/favicon-16x16.png"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "apple-touch-icon",
            t: 13,
            g: 1
          }, {
            n: "sizes",
            f: "180x180",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "publicRoot"
            }, "/icons/apple-touch-icon.png"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "manifest",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "publicRoot"
            }, "/icons/site.webmanifest"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "mask-icon",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "publicRoot"
            }, "/icons/safari-pinned-tab.svg"],
            t: 13
          }, {
            n: "color",
            f: "#e64e3d",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "msapplication-TileColor",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "#ffffff",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "msapplication-config",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: [{
              t: 2,
              r: "publicRoot"
            }, "/icons/browserconfig.xml"],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "meta",
          m: [{
            n: "name",
            f: "theme-color",
            t: 13,
            g: 1
          }, {
            n: "content",
            f: "#ffffff",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 16,
          r: "seo"
        }, " ", {
          t: 9,
          c: " Maybe will be useful in Firefox at some point. "
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "dns-prefetch",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: "https://cdn.jsdelivr.net/",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 9,
          c: "\t\t\t<link rel=\"dns-prefetch\" href=\"https://datum.jsdelivr.com/\">"
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "preconnect",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: "https://cdn.jsdelivr.net/",
            t: 13,
            g: 1
          }, {
            n: "crossorigin",
            f: "anonymous",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 9,
          c: "\t\t\t<link rel=\"preconnect\" href=\"https://datum.jsdelivr.com/\" crossorigin=\"anonymous\">"
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "stylesheet",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/css/app.css?v=", {
              t: 2,
              r: "@shared.assetsVersion"
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "stylesheet",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: "https://cdn.jsdelivr.net/npm/font-awesome@4.7.0/css/font-awesome.min.css",
            t: 13,
            g: 1
          }, {
            n: "media",
            f: "print",
            t: 13,
            g: 1
          }, {
            n: "onload",
            f: "this.media='all'",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "link",
          m: [{
            n: "rel",
            f: "sitemap",
            t: 13,
            g: 1
          }, {
            n: "href",
            f: "/sitemap/index.xml",
            t: 13,
            g: 1
          }, {
            n: "type",
            f: "application/xml",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "style",
          f: ["\t\t\t\t@font-face {\n\t\t\t\t\tfont-family: 'Lexend';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 100 900;\n\t\t\t\t\tsrc: url(https://cdn.jsdelivr.net/fontsource/fonts/lexend:vf@latest/latin-wght-normal.woff2) format('woff2-variations');\n\t\t\t\t}\n\n\t\t\t\t@font-face {\n\t\t\t\t\tfont-family: 'Source Code Pro';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 200 900;\n\t\t\t\t\tsrc: url(https://cdn.jsdelivr.net/fontsource/fonts/source-code-pro:vf@latest/latin-wght-normal.woff2) format('woff2-variations');\n\t\t\t\t}\n\t\t\t"]
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            n: "type",
            f: "application/ld+json",
            t: 13,
            g: 1
          }],
          f: ["\t\t\t\t{\n\t\t\t\t\t\"@context\": \"https://schema.org\",\n\t\t\t\t\t\"@type\": \"Organization\",\n\t\t\t\t\t\"name\": \"Globalping\",\n\t\t\t\t\t\"alternateName\": \"globalping\",\n\t\t\t\t\t\"description\": \"A global, open source, network testing and monitoring platform\",\n\t\t\t\t\t\"url\": \"https://globalping.io\",\n\t\t\t\t\t\"logo\": \"https://cdn.jsdelivr.net/gh/jsdelivr/globalping-media@refs/heads/master/logo/full_colored_dark.svg\",\n\t\t\t\t\t\"sameAs\": [\n\t\t\t\t\t\t\"https://x.com/jsdelivr\",\n\t\t\t\t\t\t\"https://www.linkedin.com/company/globalping/\",\n\t\t\t\t\t\t\"https://github.com/jsdelivr/globalping\"\n\t\t\t\t\t]\n\t\t\t\t}\n\t\t\t"]
        }, " ", {
          t: 16,
          r: "css"
        }]
      }, " ", {
        t: 7,
        e: "body",
        f: [{
          t: 7,
          e: "div",
          m: [{
            n: "id",
            f: "page",
            t: 13,
            g: 1
          }],
          f: [{
            t: 4,
            f: [{
              t: 16
            }],
            n: 51,
            r: "noYield"
          }]
        }, " ", {
          t: 7,
          e: "r-serialize"
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            t: 13,
            n: "class",
            f: "prerequisite-script",
            g: 1
          }, {
            n: "src",
            f: "https://cdn.jsdelivr.net/npm/jquery@3.6.3/dist/jquery.slim.min.js",
            t: 13,
            g: 1
          }, {
            n: "onload",
            f: "this.loaded=true",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            t: 13,
            n: "class",
            f: "prerequisite-script",
            g: 1
          }, {
            n: "src",
            f: "https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/js/bootstrap.min.js",
            t: 13,
            g: 1
          }, {
            n: "onload",
            f: "this.loaded=true",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            t: 13,
            n: "class",
            f: "prerequisite-script",
            g: 1
          }, {
            n: "src",
            f: ["https://cdn.jsdelivr.net/gh/MartinKolarik/RapiDoc@customized/dist/rapidoc-min.js?v=", {
              t: 2,
              r: "@shared.assetsVersion"
            }],
            t: 13
          }, {
            n: "onload",
            f: "this.loaded=true",
            t: 13,
            g: 1
          }]
        }, " ", {
          t: 16,
          r: "js"
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            n: "type",
            f: "module",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: [{
              t: 2,
              r: "@shared.assetsHost"
            }, "/js/app-docs.js?v=", {
              t: 2,
              r: "@shared.assetsVersion"
            }],
            t: 13
          }]
        }, " ", {
          t: 7,
          e: "script",
          m: [{
            n: "defer",
            f: 0,
            t: 13
          }, {
            n: "data-domain",
            f: "jsdelivr.com",
            t: 13,
            g: 1
          }, {
            n: "src",
            f: "https://datum.jsdelivr.com/js/script.js",
            t: 13,
            g: 1
          }]
        }]
      }]
    }],
    n: 51,
    l: 1
  }],
  e: {
    "!_0": function (_0) {
      return !_0;
    },
    "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\"": function (_0) {
      return _0 || "Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.";
    },
    "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\"": function (_0) {
      return _0 || "Globalping - Internet and web infrastructure monitoring and benchmarking";
    }
  }
};
component$2.exports.components = {
  "r-serialize": rSerialize
};
var rDocs = ractive.extend(component$2.exports);

var debounce = (fn, wait = 100) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(fn, wait, ...args);
  };
};

var throttle = (fn, wait = 100) => {
  let lastCalled, timeout;
  return (...args) => {
    let now = Date.now();
    if (lastCalled && now - lastCalled < wait) {
      clearTimeout(timeout);
      return timeout = setTimeout(fn, wait - (now - lastCalled), ...args);
    }
    lastCalled = now;
    clearTimeout(timeout);
    fn(...args);
  };
};

const addManagedListener = (component, target, event, handler) => {
  if (!target || typeof target.addEventListener !== 'function' || typeof target.removeEventListener !== 'function') {
    console.warn('Invalid target passed to addManagedListener');
    return;
  }
  target.addEventListener(event, handler);
  if (!component || typeof component.on !== 'function') {
    console.warn('Invalid component passed to addManagedListener');
    return;
  }
  component.on('unrender', () => {
    target.removeEventListener(event, handler);
  });
};
var addManagedListener_1 = addManagedListener;
var screenWidthListener = component => {
  component.set('screenWidth', window.innerWidth);
  addManagedListener(component, window, 'resize', debounce(throttle(() => component.set('screenWidth', window.innerWidth), 200)));
};
var stickySidebarScrollListener = component => {
  let sidebar = document.querySelector('.page-content_side-menu');
  if (sidebar) {
    let top = sidebar.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
    let handleStickySidebarScroll = () => {
      let y = document.scrollingElement.scrollTop;
      let currentSidebarTop = sidebar.getBoundingClientRect().top;
      if (currentSidebarTop <= 20 && currentSidebarTop >= 0 || y > top) {
        sidebar.setAttribute('style', 'position: sticky; top: 20px');
      } else {
        sidebar.removeAttribute('style');
      }
    };
    addManagedListener(component, window, 'scroll', handleStickySidebarScroll);
    handleStickySidebarScroll();
  }
};
var listeners = {
  addManagedListener: addManagedListener_1,
  screenWidthListener: screenWidthListener,
  stickySidebarScrollListener: stickySidebarScrollListener
};

var component$1 = {
  exports: {}
};
component$1.exports = {
  data() {
    return {
      title: 'Globalping API',
      description: 'Use the Globalping API to access thousands of global probes and build your own tools and integrations.'
    };
  },
  computed: {
    readStyle() {
      return this.get('screenWidth') < 768 ? 'view' : 'read';
    }
  },
  onrender() {
    if (!ractive.isServer) {
      this.set('screenWidth', window.innerWidth);
      listeners.screenWidthListener(this);
      this.find('rapi-doc').addEventListener('before-render', () => {
        this.set('loaded', true);
      });
    }
  }
};
component$1.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-docs",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "style",
      f: ["\t\t", {
        t: 4,
        f: ["\n\t\t\t[slot] {\n\t\t\t\tdisplay: none;\n\t\t\t}\n"],
        n: 51,
        r: "loaded"
      }, "\t"]
    }, " ", {
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-dark-bg header-fw-docs",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "rapi-doc",
        m: [{
          n: "spec-url",
          f: [{
            t: 2,
            r: "@shared.apiDocsHost"
          }, "/v1/spec.yaml"],
          t: 13
        }, {
          n: "id",
          f: "thedoc",
          t: 13,
          g: 1
        }, {
          n: "theme",
          f: "light",
          t: 13,
          g: 1
        }, {
          n: "load-fonts",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "render-style",
          f: [{
            t: 2,
            r: "readStyle"
          }],
          t: 13
        }, {
          n: "regular-font",
          f: "Lexend, sans-serif",
          t: 13,
          g: 1
        }, {
          n: "mono-font",
          f: "'Source Code Pro', monospace",
          t: 13,
          g: 1
        }, {
          n: "show-header",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-search",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "allow-advanced-search",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-spec-url-load",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-spec-file-load",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-spec-file-download",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "allow-server-selection",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-authentication",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "schema-description-expanded",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "schema-expand-level",
          f: "1",
          t: 13,
          g: 1
        }, {
          n: "match-type",
          f: "includes",
          t: 13,
          g: 1
        }, {
          n: "allow-schema-description-expand-toggle",
          f: "false",
          t: 13,
          g: 1
        }],
        f: []
      }],
      n: 50,
      r: "screenWidth"
    }]
  }]
};
component$1.exports.components = {
  "c-header-gradient": headerGradient,
  "c-notification": notification,
  "c-gp-header": header,
  "r-docs": rDocs
};
var api_globalping_io = ractive.extend(component$1.exports);

var component = {
  exports: {}
};
component.exports = {
  data() {
    return {
      title: 'Globalping Authentication API',
      description: 'Authenticate your Globalping integrations using our OAuth API for the best user flow.'
    };
  },
  computed: {
    readStyle() {
      return this.get('screenWidth') < 768 ? 'view' : 'read';
    }
  },
  onrender() {
    if (!ractive.isServer) {
      this.set('screenWidth', window.innerWidth);
      listeners.screenWidthListener(this);
      this.find('rapi-doc').addEventListener('before-render', () => {
        this.set('loaded', true);
      });
    }
  }
};
component.exports.template = {
  v: 4,
  t: [{
    t: 7,
    e: "r-docs",
    m: [{
      n: "noYield",
      f: [{
        t: 2,
        r: "noYield"
      }],
      t: 13
    }, {
      n: "title",
      f: [{
        t: 2,
        r: "title"
      }],
      t: 13
    }, {
      n: "description",
      f: [{
        t: 2,
        r: "description"
      }],
      t: 13
    }],
    f: [{
      t: 7,
      e: "style",
      f: ["\t\t", {
        t: 4,
        f: ["\n\t\t\t[slot] {\n\t\t\t\tdisplay: none;\n\t\t\t}\n"],
        n: 51,
        r: "loaded"
      }, "\t"]
    }, " ", {
      t: 7,
      e: "c-notification"
    }, " ", {
      t: 7,
      e: "c-gp-header",
      m: [{
        n: "additionalClasses",
        f: "header-with-dark-bg header-fw-docs",
        t: 13,
        g: 1
      }]
    }, " ", {
      t: 4,
      f: [{
        t: 7,
        e: "rapi-doc",
        m: [{
          n: "spec-url",
          f: "https://auth.globalping.io/spec.yaml",
          t: 13,
          g: 1
        }, {
          n: "id",
          f: "thedoc",
          t: 13,
          g: 1
        }, {
          n: "theme",
          f: "light",
          t: 13,
          g: 1
        }, {
          n: "load-fonts",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "render-style",
          f: [{
            t: 2,
            r: "readStyle"
          }],
          t: 13
        }, {
          n: "regular-font",
          f: "Lexend, sans-serif",
          t: 13,
          g: 1
        }, {
          n: "mono-font",
          f: "'Source Code Pro', monospace",
          t: 13,
          g: 1
        }, {
          n: "show-header",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-search",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "allow-advanced-search",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-spec-url-load",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-spec-file-load",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-spec-file-download",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "allow-server-selection",
          f: "false",
          t: 13,
          g: 1
        }, {
          n: "allow-authentication",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "schema-description-expanded",
          f: "true",
          t: 13,
          g: 1
        }, {
          n: "schema-expand-level",
          f: "1",
          t: 13,
          g: 1
        }, {
          n: "match-type",
          f: "includes",
          t: 13,
          g: 1
        }, {
          n: "allow-schema-description-expand-toggle",
          f: "false",
          t: 13,
          g: 1
        }],
        f: []
      }],
      n: 50,
      r: "screenWidth"
    }]
  }]
};
component.exports.components = {
  "c-header-gradient": headerGradient,
  "c-notification": notification,
  "c-gp-header": header,
  "r-docs": rDocs
};
var auth_globalping_io = ractive.extend(component.exports);

const awaitScriptLoad = initApp => {
  let reqPlugins = Array.from(document.querySelectorAll('.prerequisite-script'));
  let pluginsReady = false;
  let pluginPromises = reqPlugins.map(plugin => {
    return new Promise(resolve => {
      if (plugin.loaded) {
        resolve(plugin);
        return;
      }
      plugin.addEventListener('load', () => resolve(plugin), {
        once: true
      });
      plugin.addEventListener('error', () => resolve(plugin), {
        once: true
      });
    });
  });
  Promise.all(pluginPromises).then(() => {
    pluginsReady = true;
    tryInitApp();
  });
  Promise.all([import('https://cdn.jsdelivr.net/npm/ractive@1.4.4/runtime.min.mjs'),
  // eslint-disable-next-line n/no-missing-import
  import('https://cdn.jsdelivr.net/npm/ractive-route@0.3.13/ractive-route.min.mjs')]).then(([{
    default: Ractive
  }, {
    Router
  }]) => {
    Ractive.Router = Router;
    commonjsGlobal.Ractive = Ractive;
    tryInitApp();
  });
  let tryInitApp = () => {
    if (typeof Ractive !== 'undefined' && pluginsReady) {
      initApp();
    }
  };
};
var awaitScriptLoad_1 = awaitScriptLoad;

const initApp = () => {
  Ractive.DEBUG = location.hostname === 'localhost';
  commonjsGlobal.app = app;
  app.router = new Ractive.Router({
    el: '#page',
    data() {
      return {
        app
      };
    }
  });
  let routerDispatch = Ractive.Router.prototype.dispatch;
  Ractive.Router.prototype.dispatch = function (...args) {
    routerDispatch.apply(this, args);
    if (!app.router.route.view) {
      return;
    }
    return this;
  };
  app.router.addRoute('/docs/api.globalping.io', api_globalping_io);
  app.router.addRoute('/docs/auth.globalping.io', auth_globalping_io);
  _.onDocumentReady(() => {
    let state = {};
    let ractive = new Ractive();
    ractive.set('@shared.app', app);
    ractive.set('@shared.escape', escape);
    function escape(string) {
      return string.replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
    }
    try {
      let shared = JSON.parse(document.querySelector('#ractive-shared').innerHTML.trim());
      if (shared) {
        Object.keys(shared).forEach(key => {
          ractive.set(`@shared.${key}`, shared[key]);
        });
      }
    } catch {}
    try {
      state = JSON.parse(document.querySelector('#ractive-data').innerHTML.trim());
    } catch {}
    app.router.init({
      noScroll: true,
      state
    });

    // open navbar dropdowns on hover
    $(document).on('mouseenter', '.navbar .dropdown', e => setTimeout(() => $(e.target).closest('.navbar-collapse').css('position') !== 'absolute' && $(e.target).closest('.dropdown:not(.open)').find('.dropdown-toggle').dropdown('toggle'))).on('mouseleave', '.navbar .dropdown', e => setTimeout(() => $(e.target).closest('.navbar-collapse').css('position') !== 'absolute' && $(e.target).closest('.dropdown.open').find('.dropdown-toggle').dropdown('toggle')));
  });
};
let app = {
  config: {}
};
awaitScriptLoad_1(initApp);
var appDocs = app;

export { appDocs as default };
